/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/**
 * author: hao
 */

import React from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { Grid, Row } from 'react-bootstrap';
import {
    getContentByLocal,
    isEmptyObject,
    isStringEmpty,
    isArray,
    deepClone,
    setTitle,
    ToDBC,
    ToCDB,
    CheckNum
} from '../../../utils';
import AOForm from '../../../shared/AOForm';
import paths from '../../../config/path';
import {
    findQuestionById,
    findQuestionByIdInSubSection,
    replaceQuestion,
    replaceSubQuestion,
    aoformQuestionShouldDisplay,
    checkSubQuestionCondition,
    regenSubQuestionId,
    cloneQuestion,
    findPreviousOrNextQuestionId,
    shouldDisplayDefaultValue,
    isAOFormConditionMatch,
    isSubQuestionWithinQuestion,
    isConnectedParties,
    getInputContent,
    checkPercentage,
    fix,
    checkDuplicateByQuestionIndicator,
    aoformAnswerShouldDisplay,
    aoformValidationErrorCondition,
    handleIdTemplate,
    findQuestionByIdInSection,
    aoformQuestionShouldDisplay as questionShouldDisplay
} from '../../../utils/AOFormUtils';
import { handleJsonToAnswer, handleFindAnswerbyQuestionIndicator } from '../../../utils/AOFormAnswerHandler2';
import history from '../../../utils/history';
import BasePage from '../../../shared/BasePage';
import StepIndicator from '../../../shared/StepIndicator';
import { saveAOForm, completeAOForm } from '../state/action';
import '../style/ao-form.css';
import {
    numberOnly,
    decimal,
    character,
    characterNnumber,
    email,
    validationQuestion,
    chineseCharacterAndMark
} from '../../../utils/ValidationUtils';
import {
    getBusandqs,
    saveCountryList,
    saveBusinessInfo
} from '../../App/state/action';
import { FormattedHTMLMessage } from 'react-intl';
class AOFormContainer extends BasePage {

    // lifecycle
    constructor(props) {
        super(props);
        const { id } = props.match.params;
        const { form_error_prompt } = props.form_base_content;
        const errorList = [];
        const errorMsgs = {};
        this.state = {
            id,
            errorList,
            errorMsgs,
            isShowError: false,
            currentOpenPanel: null,
            form_error_prompt
        }
    }

    componentWillMount() {
        super.componentWillMount();
        const { allCountryDatas, selectedLanguage } = this.props;
        const { currentSection } = this.props;
        this.handleApplicationInfo(this.props, null, true);
        //select language to set country order
        allCountryDatas && this.props.saveCountryList(allCountryDatas, selectedLanguage);
        if(currentSection){
            this.initResOrBusOpeSitCodeLevelData(currentSection);
        }
    }

    componentWillReceiveProps(nextProps) {
        super.componentWillReceiveProps(nextProps);
        const { applicationInfo, form_base_content, allCountryDatas, selectedLanguage } = nextProps;
        const { id } = nextProps.match.params;
        const {currentSection} = this.state;
        const backToAOFormHome = () => {
            this.setState({
                currentSection: null
            });
            history.push(paths.dashboard.path);
        };
        // when the url is change
        if (this.props.match.params.id !== id) {
            this.setState({
                id,
                errorMsgs: {},
                errorList: [],
                currentSection: null,
                dialogObj: null,
                isShowError: false,
                currentOpenPanel: null
            }, () => {
                this.scrollToTop();
                this.handleApplicationInfo(this.props, backToAOFormHome, true);
            });
            return;
        } else if (this.props.applicationInfo !== applicationInfo) {
            this.handleApplicationInfo(nextProps, backToAOFormHome, false);
        }

        // change language
        if (this.props.form_base_content !== form_base_content) {
            this.setState({
                errorList: [],
                isShowError: false
            })
        }
        //select language to set country order
        if (selectedLanguage !== this.props.selectedLanguage) {
            allCountryDatas && this.props.saveCountryList(allCountryDatas, selectedLanguage);
        }

        if(currentSection){
            this.initResOrBusOpeSitCodeLevelData(currentSection);
        }

        if (id === 'Q003-006' && !sessionStorage.getItem('loadLeg')) {
            sessionStorage.setItem('loadLeg', 'N');
            window.location.reload();
        }
    }

    //RBBOB-15726 AC2
    initResOrBusOpeSitCodeLevelData = (currentSection) => {
        let { resOrBusOpeSitCodeLevelDatasRoots } = this.props
        let currentSection3218;
        currentSection.subQuestions && currentSection.subQuestions.map((item, index) => {
            if(item.questionId === "Q003-001-3218") {
                currentSection3218 =  item && item.subQuestions && item.subQuestions[0]; // 找到：Q003-001-3218-001
            }
        })
        let rootIndex = 0
        const obj1Answer = currentSection3218 && currentSection3218.subQuestions[0] && currentSection3218.subQuestions[0].userAnswer;
        currentSection3218 && currentSection3218.subQuestions.map((question,id)=>{         
            if(id === 0){
                //level one question always show
                question.hide = false
                // init level one question answers
                //question.answers = resOrBusOpeSitCodeLevelDatasRoots.roots;
                question.answers = resOrBusOpeSitCodeLevelDatasRoots;
                if(question.userAnswer){
                    let userAnswer = question.userAnswer.chosenAnswerId
                    rootIndex = userAnswer.split(":")[1]*1-1
                }
                let cascadingQId = this.caculateNextQuestionId(question.questionId)
                //let cascadingQuestion = findQuestionByIdInSection(section,cascadingQId)
                let cascadingQuestion = this.findQuestionByIdInCurrentSection(currentSection,cascadingQId)
                if(!!cascadingQuestion){
                    cascadingQuestion.parentIndex = rootIndex
                }
            } else if(id === 1 && question.userAnswer){
                // questions that user have answered should show
                question.hide = false
                question.answers = resOrBusOpeSitCodeLevelDatasRoots && resOrBusOpeSitCodeLevelDatasRoots[rootIndex] && resOrBusOpeSitCodeLevelDatasRoots[rootIndex].children

                let userAnswer = question.userAnswer.chosenAnswerId
                let index1 = userAnswer.split(":")[1]*1-1
                // if second level question is answered , let's check the third question's answer(if have)
                let cascadingQId = this.caculateNextQuestionId(question.questionId)
                let cascadingQuestion = this.findQuestionByIdInCurrentSection(currentSection,cascadingQId)
                if(cascadingQuestion){
                    if(cascadingQuestion.userAnswer){
                        cascadingQuestion.hide = false
                        cascadingQuestion.answers = resOrBusOpeSitCodeLevelDatasRoots && resOrBusOpeSitCodeLevelDatasRoots[rootIndex] && resOrBusOpeSitCodeLevelDatasRoots[rootIndex].children && resOrBusOpeSitCodeLevelDatasRoots[rootIndex].children[index1] && resOrBusOpeSitCodeLevelDatasRoots[rootIndex].children[index1].children
                    }else{
                        cascadingQuestion.hide = true
                    }
                }
            } else if(id === 1 && obj1Answer){
                // questions that user have answered should show
                question.hide = false
                question.answers = resOrBusOpeSitCodeLevelDatasRoots && resOrBusOpeSitCodeLevelDatasRoots[rootIndex] && resOrBusOpeSitCodeLevelDatasRoots[rootIndex].children
            } else {
                if(question.userAnswer){
                    question.hide = false
                }else{
                    question.hide = true
                }               
            }
        })
        this.setState({currentSection: currentSection})
   }
   //RBBOB-15726 AC2
   findQuestionByIdInCurrentSection = (currentSection, id) => {
        let obj1;
        currentSection.subQuestions.map((item, index) => {
            if(item.questionId === "Q003-001-3218") {
                obj1 = item && item.subQuestions && item.subQuestions[0]; // 找到：Q003-001-3218-001
            }
        });
        let obj2;
        obj1 && obj1.subQuestions.map((item,index) => {
            if(item.questionId === id) {
                obj2 = item;
            }
        });
        return obj2;
    }

    //RBBOB-15726 AC2 点下拉area code显示其他logic
    cascadingDropDownLogicHandlerNew = (question, answer) => {
        const qId = question.questionId
        let { currentSection} = this.state
        const { applicationInfo, resOrBusOpeSitCodeLevelDatasRoots } = this.props;

        let section = {};
        if(applicationInfo){
            applicationInfo.sections.forEach((item) => {
                if(item.sectionId === "S003"){
                    section = JSON.parse(JSON.stringify(item));
                }        
            });          
        }
        
        //const resOrBusOpeSitCodeLevelArray = resOrBusOpeSitCodeLevelDatasRoots.roots;
        const resOrBusOpeSitCodeLevelArray = resOrBusOpeSitCodeLevelDatasRoots;
        const questionlevel = qId.substr(qId.length-1);
        const answerIndex = answer.split(":")[1]*1-1;

        if(questionlevel === "1"){           
            let cascadingQId = this.caculateNextQuestionId(qId)
            let cascadingQuestion = this.findQuestionByIdInCurrentSection(currentSection,cascadingQId)
            let thirdQuestionId = this.caculateNextQuestionId(cascadingQId)
            let thirdLevelQuestion = this.findQuestionByIdInCurrentSection(currentSection,thirdQuestionId)
            if(cascadingQuestion && answer){
                cascadingQuestion.hide = false;
                cascadingQuestion.userAnswer = null;
                const answers = resOrBusOpeSitCodeLevelArray && resOrBusOpeSitCodeLevelArray[answerIndex] && resOrBusOpeSitCodeLevelArray[answerIndex].children 
                if(answers){
                    cascadingQuestion.answers = answers
                    cascadingQuestion.parentIndex = answerIndex
                } else { // me add
                    cascadingQuestion.hide = true;
                    cascadingQuestion.userAnswer = null;
                }
            }else if(answer === ""){
                cascadingQuestion.hide = true;
                cascadingQuestion.userAnswer = null;
            }
            if(thirdLevelQuestion){
                thirdLevelQuestion.hide = true
                thirdLevelQuestion.userAnswer = null
            }        
        }else if(questionlevel === "2"){
            let cascadingQId = this.caculateNextQuestionId(qId)
            let cascadingQuestion = this.findQuestionByIdInCurrentSection(currentSection,cascadingQId)
            if(cascadingQuestion && answer){
                const praretIndex = question.parentIndex
                const answers = resOrBusOpeSitCodeLevelArray && resOrBusOpeSitCodeLevelArray[praretIndex] && resOrBusOpeSitCodeLevelArray[praretIndex].children && resOrBusOpeSitCodeLevelArray[praretIndex].children[answerIndex] && resOrBusOpeSitCodeLevelArray[praretIndex].children[answerIndex].children
                if(answers && isArray(answers) && answers.length > 0){
                    cascadingQuestion.answers = answers
                    cascadingQuestion.hide = false;
                    cascadingQuestion.userAnswer = null;
                } else { // me add
                    cascadingQuestion.hide = true;
                    cascadingQuestion.userAnswer = null;
                }
            }else if(answer === ""){
                cascadingQuestion.hide = true;
                cascadingQuestion.userAnswer = null;
            }     
        }
        
        this.setState({currentSection:currentSection})
    }
   //RBBOB-15726 AC2 提交时拿到数据
   buildResOrBusOpeSitCodeLevelBusinessData = () => {
        const { applicationInfo } = this.props;
        const { currentSection } = this.state;
        const app = JSON.parse(JSON.stringify(applicationInfo))
        let targetQuestion;
        currentSection & currentSection.subQuestions.map((item, index) => {
            if(item.questionId === 'Q003-001-3218') {
                targetQuestion = item && item.subQuestions && item.subQuestions[0]; // 找到：Q003-001-3218-001
            }
        })
        let temp = {}
        let tempCopy = {}
        targetQuestion && targetQuestion.subQuestions.map((q,i)=>{// Q003-001-3218-001-001, Q003-001-3218-001-002, Q003-001-3218-001-003
            if(!q.hide && q.userAnswer && q.userAnswer.chosenAnswerId){
                let userAnswer = q.userAnswer.chosenAnswerId
                const index = userAnswer.split(":")[1]*1-1                    
                temp[q.questionIndicator] = q.answers[index].indicator
                tempCopy[q.questionIndicator] = q.answers[index] && q.answers[index].leveLocales && q.answers[index].leveLocales[1].detail || "";
            }             
        });

        //获取3级菜单value
        let resOrBusOpeSitCodeLevelSlectArray = [];
        resOrBusOpeSitCodeLevelSlectArray.push(temp);

        //获取3级菜单最后一个key的value
        const cloneResOrBusOpeSitCodeLevelSlectCopyObj = JSON.parse(JSON.stringify(tempCopy));
        let resOrBusOpeSitCodeLevelSlectLastText = "";
        if(cloneResOrBusOpeSitCodeLevelSlectCopyObj){
            let lastkey="";
            for (var keyname in cloneResOrBusOpeSitCodeLevelSlectCopyObj){
                lastkey=keyname;
            }
            resOrBusOpeSitCodeLevelSlectLastText = cloneResOrBusOpeSitCodeLevelSlectCopyObj[lastkey] || ""; // 获取3级菜单最后一个key的code + text value
        }

        //拼3级的text
        const cloneResOrBusOpeSitCodeLevelSlectCopyObj2 = JSON.parse(JSON.stringify(tempCopy));
        let resOrBusOpeSitCodeLevelSlectAllText;
        if(cloneResOrBusOpeSitCodeLevelSlectCopyObj2) {
            Object.keys(cloneResOrBusOpeSitCodeLevelSlectCopyObj2).map((key) => {
                if(resOrBusOpeSitCodeLevelSlectAllText) {
                    resOrBusOpeSitCodeLevelSlectAllText = resOrBusOpeSitCodeLevelSlectAllText + cloneResOrBusOpeSitCodeLevelSlectCopyObj2[key].substring(6).replace(/\s*/g, "");
                } else {
                    resOrBusOpeSitCodeLevelSlectAllText = cloneResOrBusOpeSitCodeLevelSlectCopyObj2[key].substring(6).replace(/\s*/g, "");
                }
            })
        };
        let allText;
        if(resOrBusOpeSitCodeLevelSlectLastText) {
            allText = resOrBusOpeSitCodeLevelSlectLastText.substring(0, 6) + " " + resOrBusOpeSitCodeLevelSlectAllText; // 获取3级菜单最后一个key的code + all text value
        } else {
            allText = "";
        }

        return {
            resOrBusOpeSitCodeLevelSlectArray, resOrBusOpeSitCodeLevelSlectLastText, allText
        }
    }
    //RBBOB-15726 AC2
    caculateNextQuestionId = (questionId) => {
        let newId = questionId.slice(questionId.lastIndexOf('-')+1)*1+1
        if(newId.toString().length === 2){
            newId = "0"+newId
        }else if(newId.toString().length === 1){
            newId = "00"+newId
        }
        return newId = questionId.substr(0,questionId.lastIndexOf('-')+1)+newId
    }

    handleForm7 = () => {
        const { id, currentSection } = this.state;
        if ('Q003-007' === id) {
            if (currentSection.questionStatus === undefined || 
                currentSection.questionStatus === null || 
                currentSection.questionStatus === '0' ||
                currentSection.questionStatus === 0
            ) {
                let needToFetchBus = this.props.applicationInfo !== undefined
                const { retrvInfo, countryListDatas, industryLevelList, sectionInfo, resOrBusOpeSitCodeLevelDatasRoots } = this.props;
                if (needToFetchBus && retrvInfo && countryListDatas && industryLevelList && sectionInfo && resOrBusOpeSitCodeLevelDatasRoots) {
                    this.props.getBusandqs(this.props.applicationInfo, retrvInfo,
                        countryListDatas,
                        industryLevelList,
                        sectionInfo,
                        resOrBusOpeSitCodeLevelDatasRoots)
                }
            }
        }
    }

    handleApplicationInfo = (props, notFoundAction, needHandleForm7) => {
        const { id, nextOpenPanel } = this.state;
        const { applicationInfo, businessInfo } = props;
        let isTCdisabled = ['true', 'true'];
        if (applicationInfo && !isEmptyObject(applicationInfo)) {
            const currentSection = this.findCurrentSectionByApplication(applicationInfo, id);
            //if the email address(Q003-003-010-*-001) has answer, then the TypeOfVATInv(Q003-005-004) choose Q003-005-004:002, or choose Q003-005-004:001
            const answerDetails = businessInfo.answerDetails;
            if (currentSection) {
                currentSection.subQuestions && currentSection.subQuestions.forEach(mainItem => {
                    //Type of VAT invoice
                    if(mainItem.questionId === 'Q003-005-004') {
                        if (answerDetails.TypeOfVATInv && answerDetails.TypeOfVATInv === 'EmailInv') {
                            mainItem.userAnswer = {
                                chosenAnswerId: "A003-005-004:002"
                            }
                        } else {
                            mainItem.userAnswer = {
                                chosenAnswerId: "A003-005-004:001"
                            }
                        }
                    }
                    mainItem.subQuestions && mainItem.subQuestions.forEach(item => {
                        if (item.questionId === 'Q003-003-001-002' && item.userAnswer && item.userAnswer.chosenAnswerId) {
                            isTCdisabled = ['false', 'false']
                        }
                    })
                })
                if (nextOpenPanel) {
                    this.setState({
                        currentOpenPanel: nextOpenPanel,
                        nextOpenPanel: null,
                        currentSection,
                        isTCdisabled
                    }, () => {
                        if (needHandleForm7) {
                            this.handleForm7()
                        }
                        this.initResOrBusOpeSitCodeLevelData(currentSection);
                    })
                } else {
                    this.setState({
                        currentSection,
                        isTCdisabled
                    }, () => {
                        if (needHandleForm7) {
                            this.handleForm7()
                        }
                        this.initResOrBusOpeSitCodeLevelData(currentSection);
                    })
                }
            } else {
                notFoundAction && notFoundAction();
            }
        } else {
            notFoundAction && notFoundAction();
        }
    };

    findCurrentSectionByApplication = (application, id) => {
        const aoFormSection = findQuestionById(application, "S003");
        const { questions } = aoFormSection;

        const currentSection = questions.filter(question => question.questionId === id);
        if (currentSection && currentSection.length > 0) {
            return deepClone(currentSection[0]);
        }
        return null;
    };

    handleJsonToView = (json) => {
        // eslint-disable-next-line
        const {
            questionId,
            questionLocales,
            subQuestions,
            answers
        } = json;
        const { selectedLanguage, form_base_content, applicationInfo, stepInfo, aoStepTitle, pageTitle } = this.props;

        const isDisable = applicationInfo.status === 3;
        const questions = this.handleSubQuestion(subQuestions, isDisable);
        // form title
        const title = getContentByLocal(questionLocales, selectedLanguage);
        let contentObj = {
            title: { text: title, dataKey: "formTitle" },
            optional_msg: { text: form_base_content.optional_msg, dataKey: "optional_msg"}
        };
        if (answers && answers.length && answers.length > 0) {
            const { answerLocales, answerIndicator } = answers[0];
            contentObj = {
                ...contentObj,
                subTitle: {
                    dataKey: `${answerIndicator}-description`,
                    text: getContentByLocal(answerLocales, selectedLanguage) || ''
                }
            }
        }
        const { isShowError, id, form_error_prompt } = this.state;
        const formTitle = <AOForm.FormTitle
            content={contentObj}
            key={questionId}
            errorAtTop = {{
                // content: form_base_content.form_error_prompt,
                content: form_error_prompt,
                isDisplay: isShowError
            }}
        />;
        const currentStep = parseInt(id.slice(id.length - 1), 10);
        const stepIndicator = <StepIndicator
            currentStep={currentStep === 7 ? 6 : (currentStep === 6 ? 7 : currentStep)}
            totalStep={7}
            stepInfo={stepInfo}
            stepTitle={aoStepTitle}
            key={`step_${questionId}`} />;

        setTitle(contentObj.title.text + pageTitle);

        return [
            stepIndicator,
            formTitle,
            ...questions
        ]
    };

    handleDefaultValue = (app, question) => {
        const { condition } = question;
        if (condition) {
            const conditionObj = JSON.parse(condition);
            const { defaultValue } = conditionObj;
            if (defaultValue) {
                return this.getDefaultValue(app, question, defaultValue);
            }
        }
        return null;
    };

    getDefaultValue = (app, question, defaultValue) => {
        const { companyInfo } = this.props.businessInfo;
        const { type, value } = defaultValue;
        const { selectedLanguage } = this.props;
        if (shouldDisplayDefaultValue(app, question)) {
            switch (type) {
                case 0: { // value
                    if (question.answerType === 1 || question.answerType === 5 || question.answerType === 27 || question.answerType === 110) {
                        if (value.indexOf('*') !== -1) {
                            const newValue = question.questionId.replace('Q', 'A') + ':' + value.split(':')[1];
                            this.setUserAnswer(question, newValue);
                            return newValue;
                        }
                    }
                    this.setUserAnswer(question, value);
                    return value;
                }
                case 3: { // fromLanguage
                    const language = value && JSON.parse(value)[selectedLanguage];
                    this.setUserAnswer(question, language);
                    return language;
                }
                case 2: { // fromOtherQuestion
                    if (value) {
                        let finalValue = '';
                        const ids = value.split(',');
                        ids.forEach(id => {
                            const targetQuestion = findQuestionById(app, id);
                            const { questionId } = question;
                            const targetQuestionUserAnswer = targetQuestion && targetQuestion.userAnswer;

                            if (targetQuestionUserAnswer) {
                                let userAnswer = deepClone(targetQuestionUserAnswer);
                                let answerId = targetQuestion.questionId.replace('Q', 'A');
                                if (userAnswer.contents) {
                                    userAnswer = getInputContent(userAnswer)
                                } else if (userAnswer.chosenAnswerId && questionId) {
                                    const newAnswers = userAnswer.chosenAnswerId.split(',').map(value => {
                                        return value.replace(answerId, questionId.replace('Q', 'A'))
                                    });
                                    userAnswer = newAnswers.length > 1 ? newAnswers : newAnswers[0];
                                }
                                if (isStringEmpty(finalValue)) {
                                    finalValue = userAnswer;
                                } else {
                                    finalValue += ` ${userAnswer}`;
                                }
                            }
                        });

                        this.setUserAnswer(question, finalValue);
                        return finalValue;
                    }
                    break;
                }
                case 4: {
                    if (value) {
                        let finalValue = null;
                        const targetQuestion = findQuestionById(app, value);
                        const targetQuestionUserAnswer = targetQuestion && targetQuestion.userAnswer;
                        if (targetQuestionUserAnswer) {
                            const { answers } = targetQuestion;
                            const { chosenAnswerId } = targetQuestionUserAnswer;
                            if (chosenAnswerId) {
                                for (let i = 0; i < answers.length; i++) {
                                    const answer = answers[i];
                                    if (answer.answerId === chosenAnswerId) {
                                        finalValue = getContentByLocal(answer.answerLocales, selectedLanguage);
                                        break;
                                    }
                                }
                            }
                        }
                        this.setUserAnswer(question, finalValue);
                        return finalValue
                    }
                    break;
                }
                case 5: { // value 常驻国家（地区）名称及代码
                    let finalValue = null;
                    //代码
                    if (question.answerType === 4) {
                        if (companyInfo.registerCountry === "CN") {
                            finalValue = "CHN"
                        } else if(companyInfo.registerCountry === "HK") {
                            finalValue = "HKG"
                        } else {
                            finalValue = "OTH"
                        }
                    }
                    //地区
                    if(question.answerType === 5) {
                        if (companyInfo.registerCountry === "CN") {
                            finalValue = `${value}:001`;
                        } else if(companyInfo.registerCountry === "HK") {
                            finalValue = `${value}:002`;
                        } else {
                            finalValue = `${value}:003`;
                        }
                    }
                    this.setUserAnswer(question, finalValue);
                    return finalValue;
                }
                case 1: // prefill
                default:
                    break;
            }
        }
        return null;
    };

    genQuestionMark = (questionIndicator, questionMarkDetail) => {
        return {
            questionMark: {
                dataKey: `${questionIndicator}-questionMark`,
                hints: questionMarkDetail
            }
        }
    };

    genQuestionDescription = (questionIndicator, questionDescription) => {
        return {
            questionTip: {
                dataKey: `${questionIndicator}-description`,
                title: questionDescription
            }
        }
    };

    handleSubQuestion = (
        subQuestions,
        isDisable,
        index = 0
    ) => {

        const { selectedLanguage, form_base_content, applicationInfo, countryListDatas } = this.props;
        const { errorList, currentSection, errorMsgs } = this.state;

        const app = replaceQuestion(applicationInfo, currentSection);

        if (!subQuestions) {
            return null;
        }

        return subQuestions.map((obj) => {
            const shouldDisplay = aoformQuestionShouldDisplay(app, obj);
            if (!shouldDisplay) { return null }
            const {
                questionId,
                questionIndicator,
                questionLocales,
                answerType,
                canRepeat,
                hintLocales,
                userAnswer,
                hintStyle,
                answers } = obj;
            // const questionTitle = `${index}. ${getContentByLocal(questionLocales, selectedLanguage)}`;
            const questionTitle = getContentByLocal(questionLocales, selectedLanguage);
            const questionMarkDetail = hintLocales && getContentByLocal(hintLocales, selectedLanguage);
            const hintStyleObj = hintStyle && JSON.parse(hintStyle);
            const hintStyleType = hintStyleObj && hintStyleObj.style;
            const hasHint = typeof (hintStyleType) !== 'undefined' && hintStyleType !== null;
            const errorMsg = errorMsgs[questionId];

            const isError = errorList.indexOf(questionId) !== -1;

            let component;
            let needContainer = true;
            let defaultValue = null;

            switch (answerType) {
                case 0: // Content Only
                    {
                        let content = {
                            title: questionTitle,
                            dataKey: questionIndicator,
                        };
                        if (hasHint) {
                            content = {
                                ...this.genQuestionMark(questionIndicator, questionMarkDetail),
                                ...content
                            }
                        }
                        component = <AOForm.MainGroupTitle
                            content={content}
                        />;
                        break;
                    }
                case 1: // Radio Button
                    {
                        const radioItems = answers && answers.filter(answer => {
                            return aoformAnswerShouldDisplay(app, answer)
                        }).map(answer => {
                            return {
                                'dataIndex': answer.index,
                                'value': answer.answerId,
                                'display': getContentByLocal(answer.answerLocales, selectedLanguage),
                                'dataKey': answer.answerIndicator,
                                'displayTip': answer.hintLocales ? getContentByLocal(answer.hintLocales, selectedLanguage) : null,
                            }
                        });
                        const [disable] = this.checkDisableCondition(app, obj);
                        if (userAnswer) {
                            defaultValue = userAnswer.chosenAnswerId
                            let include = false;
                            for (let i = 0; i < radioItems.length; i++) {
                                if (radioItems[i].value === defaultValue) {
                                    include = true;
                                    break;
                                }
                            }
                            if (!include) {
                                this.setUserAnswer(obj, '')
                                defaultValue = ''
                            }
                        } else {
                            defaultValue = this.handleDefaultValue(app, obj);
                        }
                        let radioArrays = {
                            question: {
                                title: questionTitle,
                                dataKey: `${questionIndicator}`
                            },
                            radioName: questionId,
                            isError: isError,
                            errorMessage: errorMsg,
                            isDisabled: isDisable || disable,
                            defaultValue: defaultValue,
                            radioItems: radioItems,
                            questionRel: obj
                        };
                        if (hasHint) {
                            switch (hintStyleType) {
                                case 0: {
                                    radioArrays = {
                                        ...radioArrays,
                                        ...this.genQuestionMark(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                case 1: {
                                    radioArrays = {
                                        ...radioArrays,
                                        ...this.genQuestionDescription(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                default:
                                    break;
                            }
                        }
                        /*component = <AOForm.RadioButton
                            handleRadioChange={this.valueDidChange}
                            content={radioArrays}
                        />;*/

                        const { condition } = obj;
                        const conditionObj = condition && JSON.parse(condition);
                        if(conditionObj.className) {
                            const itemSubClassName = conditionObj && conditionObj.className;
                            component = <div className={itemSubClassName}><AOForm.RadioButton
                                handleRadioChange={this.valueDidChange}
                                content={radioArrays}
                            /></div>;
                        } else {
                            component = <AOForm.RadioButton
                                handleRadioChange={this.valueDidChange}
                                content={radioArrays}
                            />;
                        }
                        break;
                    }
                case 2: // Check box
                    {
                        const { form_base_content } = this.props;
                        const checkboxItems = answers && answers.filter(answer => {
                            return aoformAnswerShouldDisplay(app, answer)
                        }).map(answer => {
                            return {
                                'dataIndex': answer.index,
                                'value': answer.answerId,
                                'display': getContentByLocal(answer.answerLocales, selectedLanguage),
                                'dataKey': answer.answerIndicator,
                            }
                        });
                        if (userAnswer) {
                            defaultValue = userAnswer.chosenAnswerId && userAnswer.chosenAnswerId.split(",");
                            let removedIds = [];
                            const values = checkboxItems.map(item => {
                                return item.value
                            })
                            if (defaultValue) {
                                for (let i = 0; i < defaultValue.length; i++) {
                                    if (values.indexOf(defaultValue[i]) === -1) {
                                        removedIds.push(defaultValue[i])
                                    }
                                }
                            }

                            removedIds.forEach(id => {
                                const idIndex = defaultValue.indexOf(id)
                                defaultValue.splice(idIndex, 1)
                            })
                            if (removedIds.length > 0) {
                                this.setUserAnswer(obj, defaultValue)
                            }
                        } else {
                            defaultValue = this.handleDefaultValue(app, obj)
                        }
                        let checkboxArrays = {
                            question: {
                                title: getContentByLocal(questionLocales, selectedLanguage),
                                dataKey: `${questionIndicator}`
                            },
                            checkboxName: questionId,
                            isError: isError,
                            errorMessage: errorMsg,
                            isDisabled: isDisable,
                            defaultValue: defaultValue,
                            checkboxItems: checkboxItems,
                            questionRel: obj
                        };
                        if (hasHint) {
                            switch (hintStyleType) {
                                case 0: {
                                    checkboxArrays = {
                                        ...checkboxArrays,
                                        ...this.genQuestionMark(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                case 1: {
                                    checkboxArrays = {
                                        ...checkboxArrays,
                                        ...this.genQuestionDescription(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                default:
                                    break;
                            }
                        }
                        if (questionIndicator === 'BusBundleOfferTandC') {
                            checkboxArrays = {
                                ...checkboxArrays,
                                isDisabled: !(this.state.isTCdisabled.every(item => item === "false")),
                                linkText: [form_base_content.TC_link.linkText1, form_base_content.TC_link.linkText2]
                            }
                            component = <AOForm.CheckboxButton
                                handleCheckboxChange={this.valueDidChange}
                                content={checkboxArrays}
                                isShowTC={true}
                                onClickTC={this.onClickTC}
                                handleCheckboxOnClick={this.handleCheckboxOnClick}
                            />;
                        } else {
                            component = <AOForm.CheckboxButton
                                handleCheckboxChange={this.valueDidChange}
                                content={checkboxArrays}
                            />;
                        }
                        
                        break;
                    }
                case 4: // Input Field
                case 21: // InputDigit
                case 23: // InputPercentage
                    {
                        const { inputPreLabelLocales, inputSfxLabelLocales, condition } = obj;
                        const conditionObj = condition && JSON.parse(condition);
                        const prefix = inputPreLabelLocales && getContentByLocal(inputPreLabelLocales, selectedLanguage);
                        const suffix = inputSfxLabelLocales && getContentByLocal(inputSfxLabelLocales, selectedLanguage);
                        const [disable, displayValue] = this.checkDisableCondition(app, obj);
                        if (disable) {
                            defaultValue = this.getDefaultValue(app, obj, displayValue);
                            // if (userAnswer) {
                            //     defaultValue = getInputContent(userAnswer)
                            // }   
                        } else {
                            if (userAnswer) {
                                defaultValue = getInputContent(userAnswer)
                            } else {
                                defaultValue = this.handleDefaultValue(app, obj)
                            }
                        }
                        let inputContent = {
                            textValue: defaultValue,
                            subtitle: {
                                title: questionTitle,
                                dataKey: `${questionIndicator}-subtitle`,
                            },
                            isError: isError,
                            errorMessage: errorMsg,
                            isDisabled: isDisable || disable,
                            questionRel: obj,
                            dataKey: questionIndicator
                        };
                        if (hasHint) {
                            switch (hintStyleType) {
                                case 0: {
                                    inputContent = {
                                        ...inputContent,
                                        ...this.genQuestionMark(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                case 1: {
                                    inputContent = {
                                        ...inputContent,
                                        ...this.genQuestionDescription(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                default:
                                    break;
                            }
                        }

                        let otherParams = {
                            maxLength: null,
                            formatAction: null
                        };

                        if (conditionObj) {
                            const { inputType, maxLength } = conditionObj;
                            if (typeof (inputType) !== "undefined") {
                                switch (inputType) {
                                    case 0: { // numberOnly
                                        otherParams = {
                                            ...otherParams,
                                            formatAction: numberOnly,
                                            isNumber: true
                                        };
                                        break;
                                    }
                                    case 1: { // decimal
                                        otherParams = {
                                            ...otherParams,
                                            formatAction: decimal,
                                            isNumber: true
                                        };
                                        break;
                                    }
                                    case 2: { // character
                                        otherParams = {
                                            ...otherParams,
                                            formatAction: character
                                        };
                                        break;
                                    }
                                    case 3: { // characterNnumber
                                        otherParams = {
                                            ...otherParams,
                                            formatAction: characterNnumber
                                        };
                                        break;
                                    }
                                    case 4: { // email
                                        otherParams = {
                                            ...otherParams,
                                            formatAction: email
                                        };
                                        break;
                                    }
                                    default:
                                        { break; }
                                }
                            }
                            if (typeof (maxLength) !== "undefined") {
                                otherParams = {
                                    ...otherParams,
                                    maxLength
                                }
                            }
                        }

                        const isPercentage = (answerType === 23);

                        component = <AOForm.InputWithPrefixSuffix
                            onChangeAction={this.valueDidChange}
                            content={inputContent}
                            disabled={isDisable}
                            prefix={prefix}
                            suffix={suffix}
                            isPercentage={isPercentage}
                            onBlurAction={this.onBlurAction}
                            {...otherParams}
                        />;
                        break;
                    }
                case 5: // Drop down list
                case 27: // CountryList
                    {
                        let answerOptions = null
                        const [disable, displayValue] = this.checkDisableCondition(app, obj);
                        
                        if (answerType === 5) {
                            answerOptions = answers && answers.filter(answer => {
                                return aoformAnswerShouldDisplay(app, answer)
                            }).map(item => {
                                return {
                                    id: item.answerId,
                                    text: getContentByLocal(item.answerLocales, selectedLanguage),
                                    dataKey: item.answerIndicator
                                }
                            });
                        } else if (answerType === 27) {
                            const baseAnswerId = questionId.replace('Q', 'A') + ":";

                            answerOptions = countryListDatas && countryListDatas.map((item, index) => {
                                const answerId = baseAnswerId + fix(index + 1)
                                return {
                                    id: answerId,
                                    text: getContentByLocal(item.leveLocales, selectedLanguage),
                                    dataKey: `${questionIndicator}_${item.indicator}`
                                }
                            });
                        }

                        if (answerOptions) {
                            answerOptions = [{ id: "", 'text': form_base_content.drop_down_list_place_holder }, ...answerOptions];
                        }
                        if (disable) {
                            defaultValue = this.getDefaultValue(app, obj, displayValue);  
                        } else {
                            if (userAnswer) {
                                defaultValue = userAnswer.chosenAnswerId
                                let include = false;
                                for (let i = 0; i < answerOptions.length; i++) {
                                    if (answerOptions[i].id === defaultValue) {
                                        include = true;
                                        break;
                                    }
                                }
                                if (!include) {
                                    this.setUserAnswer(obj, '')
                                    defaultValue = ''
                                }
                            } else {
                                defaultValue = this.handleDefaultValue(app, obj)
                            }
                        }
                        
                        let selectContent = {
                            itemTitle: {
                                text: questionTitle,
                                dataKey: `${questionIndicator}-subtitle`
                            },
                            validatedTips: isError ? errorMsg : '',
                            selectOptions: answerOptions,
                            defaultValue: defaultValue,
                            questionRel: obj,
                            dataKey: questionIndicator,
                            isError: isError
                        };
                        if (hasHint) {
                            switch (hintStyleType) {
                                case 0: {
                                    selectContent = {
                                        ...selectContent,
                                        ...this.genQuestionMark(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                case 1: {
                                    selectContent = {
                                        ...selectContent,
                                        ...this.genQuestionDescription(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                default:
                                    break;
                            }
                        }
                        //console.log()
                        component = <AOForm.Select
                            content={selectContent}
                            disabled={isDisable || disable}
                            onChangeAction={(obj, newValue) => { this.valueDidChange(obj, newValue) }}

                        />;
                        break;
                    }
                case 110://resOrBusOpeSitCodeLevel
                    {
                        let answerOptions = null
                        const [disable, displayValue] = this.checkDisableCondition(app, obj);
                        
                        if (answerType === 110) {
                            if(obj.hide){
                                return false;
                            }
                            const baseAnswerId = questionId.replace('Q', 'A') + ":"; 
                            answerOptions = answers && answers.filter(answer => {
                                return aoformAnswerShouldDisplay(app, answer)
                            }).map((answer, index) => {
                                const answerId = baseAnswerId + fix(index + 1)
                                return {
                                    //id: answer.answerId,
                                    id: answerId,
                                    text: getContentByLocal(answer.leveLocales, selectedLanguage),
                                    dataKey: `${questionIndicator}_${answer.indicator}`
                                }
                            });
                        }

                        if (answerOptions) {
                            answerOptions = [{ id: "", 'text': form_base_content.drop_down_list_place_holder }, ...answerOptions];
                        }
                        if (disable) {
                            defaultValue = this.getDefaultValue(app, obj, displayValue);  
                        } else {
                            if (userAnswer) {
                                defaultValue = userAnswer.chosenAnswerId
                                let include = false;
                                if(answerOptions){
                                    for (let i = 0; i < answerOptions.length; i++) {
                                        if (answerOptions[i].id === defaultValue) {
                                            include = true;
                                            break;
                                        }
                                    }
                                }
                                if (!include) {
                                    //this.setUserAnswer(obj, '')
                                    defaultValue = ''
                                }
                            } else {
                                defaultValue = this.handleDefaultValue(app, obj)
                            }
                        }
                        
                        let selectContent = {
                            itemTitle: {
                                text: questionTitle,
                                dataKey: `${questionIndicator}-subtitle`
                            },
                            validatedTips: isError ? errorMsg : '',
                            selectOptions: answerOptions,
                            defaultValue: defaultValue,
                            questionRel: obj,
                            dataKey: questionIndicator,
                            isError: isError
                        };
                        if (hasHint) {
                            switch (hintStyleType) {
                                case 0: {
                                    selectContent = {
                                        ...selectContent,
                                        ...this.genQuestionMark(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                case 1: {
                                    selectContent = {
                                        ...selectContent,
                                        ...this.genQuestionDescription(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                default:
                                    break;
                            }
                        }
                        //console.log()
                        component = answerOptions && <AOForm.Select
                            content={selectContent}
                            disabled={isDisable || disable}
                            onChangeAction={(obj, newValue) => { this.valueDidChange(obj, newValue) }}

                        />;
                        break;
                    }
                case 7: // Mobile Phone
                    {
                        let mobilePhone = null;
                        const [disable] = this.checkDisableCondition(app, obj);
                        if (userAnswer) {
                            defaultValue = getInputContent(userAnswer);
                            if (defaultValue) {
                                mobilePhone = defaultValue.split("-")
                            }
                        } else {
                            defaultValue = this.handleDefaultValue(app, obj)
                        }
                        const [areaQuestion, phoneQuestion] = obj.subQuestions;

                        const mobileContent = {
                            question: {
                                title: questionTitle,
                                dataKey: `${questionIndicator}-subtitle`
                            },
                            areaItem: {
                                textValue: mobilePhone ? mobilePhone[0] : '',
                                subtitle: {
                                    title: getContentByLocal(areaQuestion.questionLocales, selectedLanguage),
                                    dataKey: `${areaQuestion.questionIndicator}-subtitle`
                                },
                                //isError: errorList.indexOf(areaQuestion.questionId) !== -1,
                                //errorMessage: errorMsg,
                                isDisabled: isDisable || disable,
                                questionRel: areaQuestion,
                                dataKey: areaQuestion.questionIndicator
                            },
                            phoneItem: {
                                textValue: mobilePhone ? mobilePhone[1] : '',
                                subtitle: {
                                    title: getContentByLocal(phoneQuestion.questionLocales, selectedLanguage),
                                    dataKey: `${phoneQuestion.questionIndicator}-subtitle`,
                                },
                                //isError: errorList.indexOf(phoneQuestion.questionId) !== -1,
                                //errorMessage: errorMsg,
                                isDisabled: isDisable || disable,
                                questionRel: phoneQuestion,
                                dataKey: phoneQuestion.questionIndicator
                            }
                        };
                        component = (<div className="phone-combined-component">
                            {/* <AOForm.MainGroupTitle
                            content={mobileContent.subtitle}
                        />*/}
                            <AOForm.ItemTitle
                                content={mobileContent}
                            />
                            <AOForm.InputMobile
                                mobilePhoneChangeAction={this.valueDidChange}
                                handleBlurAction={this.onBlurAction}
                                content={mobileContent}
                                isError={isError}
                                errorMessage={errorMsg}
                                questionRel={obj}
                            />
                        </div>);
                        break;
                    }
                case 8: // Office Phone
                    {
                        let officePhone = null;
                        const [disable] = this.checkDisableCondition(app, obj);
                        if (userAnswer) {
                            defaultValue = getInputContent(userAnswer);
                            if (defaultValue) {
                                officePhone = defaultValue.split("-")
                            }
                        } else {
                            defaultValue = this.handleDefaultValue(app, obj)
                        }
                        const [countryCode, officePhoneAreaCode, officePhoneNum] = obj.subQuestions;
                        // const officePhoneCountryCodeQuestionMark = countryCode.hintLocales &&
                        // getContentByLocal(countryCode.hintLocales, selectedLanguage);

                        const officePhoneCountryCodeContent = {
                            textValue: officePhone ? officePhone[0] : '',
                            subtitle: {
                                title: getContentByLocal(countryCode.questionLocales, selectedLanguage),
                                dataKey: `${countryCode.questionIndicator}-subtitle`
                            },
                            //isError: errorList.indexOf(countryCode.questionId) !== -1,
                            //errorMessage: errorMsg,
                            isDisabled: isDisable || disable,
                            questionRel: countryCode,
                            dataKey: countryCode.questionIndicator
                        };
                        // const officePhoneAreaCodeErrorMsg = obj.subQuestions[1].mandatoryConditions &&
                        //     obj.subQuestions[1].mandatoryConditions.errorLocale &&
                        //     getContentByLocal(obj.subQuestions[1].mandatoryConditions.errorLocale, selectedLanguage);
                        // const officePhoneAreaCodeQuestionMark = officePhoneAreaCode.hintLocales &&
                        //     getContentByLocal(officePhoneAreaCode.hintLocales, selectedLanguage);
                        const officePhoneAreaCodeContent = {
                            textValue: officePhone ? officePhone[1] : '',
                            subtitle: {
                                title: getContentByLocal(officePhoneAreaCode.questionLocales, selectedLanguage),
                                dataKey: `${officePhoneAreaCode.questionIndicator}-subtitle`
                            },

                            //isError: errorList.indexOf(officePhoneAreaCode.questionId) !== -1,
                            //errorMessage: errorMsg,
                            isDisabled: isDisable || disable,
                            questionRel: officePhoneAreaCode,
                            dataKey: officePhoneAreaCode.questionIndicator
                        };
                        // const officePhoneNumErrorMsg = obj.subQuestions[2].mandatoryConditions &&
                        //     obj.subQuestions[2].mandatoryConditions.errorLocale &&
                        //     getContentByLocal(obj.subQuestions[2].mandatoryConditions.errorLocale, selectedLanguage);
                        // const officePhoneNumQuestionMark = officePhoneNum.hintLocales &&
                        //     getContentByLocal(officePhoneNum.hintLocales, selectedLanguage);
                        const officePhoneNumContent = {
                            textValue: officePhone ? officePhone[2] : '',
                            subtitle: {
                                title: getContentByLocal(officePhoneNum.questionLocales, selectedLanguage),
                                dataKey: `${officePhoneNum.questionIndicator}-subtitle`
                            },
                            //isError: errorList.indexOf(officePhoneNum.questionId) !== -1,
                            //errorMessage: errorMsg,
                            isDisabled: isDisable || disable,
                            questionRel: officePhoneNum,
                            dataKey: officePhoneNum.questionIndicator
                        };
                        let questionMarkObj = {};
                        if (hasHint && hintStyleType === 0) {
                            questionMarkObj = this.genQuestionMark(questionIndicator, questionMarkDetail)
                        }
                        component = <div className="phone-combined-component">
                            <AOForm.ItemTitle
                                content={{
                                    question: {
                                        title: questionTitle,
                                        dataKey: questionIndicator
                                    },
                                    ...questionMarkObj
                                }}
                            />
                            <AOForm.InputOfficePhone
                                isError={isError}
                                errorMessage={errorMsg}
                                countryCodeContent={officePhoneCountryCodeContent}
                                areaCodeContent={officePhoneAreaCodeContent}
                                phoneNumContent={officePhoneNumContent}
                                officePhoneChangeAction={this.valueDidChange}
                                questionRel={obj}
                            />
                        </div>;
                        break;
                    }
                case 13: // RegionProportional
                    {
                        component = this.handleRegionProportional(obj, isDisable);
                        break;
                    }
                case 14: // Repeat group
                    {
                        if (!canRepeat) {
                            component = this.handleRepeatGroup(obj, isDisable, hasHint, hintStyleType, questionMarkDetail);
                        } else {
                            const { subQuestions, index } = obj;
                            if (subQuestions) {
                                component = this.handleSubQuestion(subQuestions, isDisable, index);
                            }
                        }
                        break;
                    }
                case 16: // Input date
                    {
                        let dates = null;
                        const [disable] = this.checkDisableCondition(app, obj);
                        if (userAnswer) {
                            defaultValue = getInputContent(userAnswer);
                            if (defaultValue) {
                                dates = defaultValue.split("-")
                            }
                        }

                        const { day, month, year } = form_base_content.year_month_day;
                        let content = {
                            question:{
                                title: questionTitle,
                                dataKey:`${questionIndicator}-subtitle`
                            }
                        };
                        if (hasHint) {
                            switch (hintStyleType) {
                                case 0: {
                                    content = {
                                        ...content,
                                        ...this.genQuestionMark(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                case 1: {

                                    content = {
                                        ...content,
                                        //...this.genQuestionDescription(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                case 2: {

                                    content = {
                                        ...content,
                                        ...this.genQuestionDescription(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                default:
                                    break;
                            }

                        }
                        const dayContent = {
                            textValue: dates ? dates[0] : '',
                            subtitle: {
                                title: day,
                                dataKey: 'day-label'
                            },
                            dataKey: 'day-input',
                            isDisabled: isDisable || disable
                        };
                        const monthContent = {
                            textValue: dates ? dates[1] : '',
                            subtitle: {
                                title: month,
                                dataKey: 'month-label'
                            },
                            dataKey: 'month-input',
                            isDisabled: isDisable || disable
                        };
                        const yearContent = {
                            textValue: dates ? dates[2] : '',
                            subtitle: {
                                title: year,
                                dataKey: 'year-label'
                            },
                            dataKey: 'year-input',
                            isDisabled: isDisable || disable
                        };

                        component = <AOForm.DateField
                            isError={isError}
                            dayContent={dayContent}
                            monthContent={monthContent}
                            yearContent={yearContent}
                            errorMessage={errorMsg}
                            content={content}
                            dateChangeAction={this.valueDidChange}
                            questionRel={obj}
                            blurAction={this.onBlurAction}
                        />;
                        break;
                    }
                case 17: // SelectGroup
                    {
                        component = this.handleSelectGroup(obj, isDisable);
                        break;
                    }
                case 170: // ResOrBusOpeSitCodeLevelGroup
                    {
                        component = this.handleResOrBusOpeSitCodeLevelSelectGroup(obj, isDisable);
                        break;
                    }
                case 18: // EmailGroup
                    {
                        component = this.handleEmailGroup(obj, isDisable);
                        break;
                    }
                case 19: // Warning
                    {
                        const info = answers && answers.length > 0 && getContentByLocal(answers[0].answerLocales, selectedLanguage);
                        if (hintStyleType !== null && typeof (hintStyle) !== 'undefined') {
                            switch (hintStyleType) {
                                case 5: {
                                    const warningBoxObj = {
                                        type: 'mainWarning', // "warning main"
                                        content: {
                                            title: {
                                                text: questionTitle,
                                                dataKey: 'warningMessageTitle'
                                            },
                                            info: {
                                                text: info,
                                                dataKey: 'warningMessageInfo'
                                            }

                                        }
                                    };
                                    component = <AOForm.MsgBox {...warningBoxObj} />;
                                    break;
                                }
                                case 2: {
                                    needContainer = false;
                                    const warningBoxObj = {
                                        type: 'warning', // "warning || success"
                                        content: {
                                            title: {
                                                text: questionTitle,
                                                dataKey: 'warningMessageTitle'
                                            },
                                            info: {
                                                text: info,
                                                dataKey: 'warningMessageInfo'
                                            }

                                        }
                                    };
                                    component = <AOForm.MsgBox {...warningBoxObj} />;
                                    break;
                                }
                                case 3: {
                                    const warningBoxObj = {
                                        type: 'success', // "warning || success"
                                        content: {
                                            title: {
                                                text: questionTitle,
                                                dataKey: 'successMessageTitle'
                                            },
                                            info: {
                                                text: info,
                                                dataKey: 'successMessageInfo'
                                            }
                                        }
                                    };
                                    component = <AOForm.MsgBox {...warningBoxObj} />;
                                    break;
                                }
                                case 4: {
                                    const itemList = obj.subQuestions && obj.subQuestions.map(item => {
                                        const { questionLocales } = item;
                                        return {
                                            text: getContentByLocal(questionLocales, selectedLanguage),
                                            dataKey: item.questionIndicator
                                        }
                                    });

                                    const content = {
                                        title: {
                                            text: questionTitle,
                                            dataKey: ""
                                        },
                                        captionArray: itemList
                                    };

                                    component = <AOForm.CaptionBox
                                        content={content}
                                    />;
                                    break;
                                }
                                case 6: {
                                    component = <div className="tips-one">{info}</div>;
                                    break;
                                }
                                case 7: {
                                    component = <div className="tips-two">{info}</div>;
                                    break;
                                }
                                case 8: {
                                    const content = {
                                        title: {
                                            text: questionTitle,
                                            dataKey: 'BAcTypeTipTitle'
                                        },
                                        info: {
                                            text: info,
                                            dataKey: 'BAcTypeTipDetail'
                                        }

                                    };
                                    component = <FormattedHTMLMessage
                                        id={content.info.text}
                                        defaultMessage={content.info.text}
                                    />;
                                    break;
                                }
                                default:
                                    break;
                            }
                        }
                        break;
                    }
                case 20: // SingleLine
                    {
                        component = <AOForm.DividingLine />;
                        break;
                    }
                case 22:// PanelGroup
                    {
                        needContainer = false;
                        component = this.handlePanelList(obj, isDisable);
                        break;
                    }
                case 24: // TextArea
                    {
                        if (userAnswer) {
                            defaultValue = getInputContent(userAnswer)
                        } else {
                            defaultValue = this.handleDefaultValue(app, obj)
                        }
                        let textareaContent = {
                            question: {
                                title: questionTitle,
                                dataKey: 'TextareaTitle'
                            },
                            value: defaultValue,
                            placeholder: '',
                            dataKey: questionIndicator,
                            isError: isError,
                            errorMessage: errorMsg,
                            questionRel: obj,
                            isDisabled: isDisable
                        };
                        if (hasHint) {
                            switch (hintStyleType) {
                                case 0: {
                                    textareaContent = {
                                        ...textareaContent,
                                        ...this.genQuestionMark(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                case 1: {
                                    textareaContent = {
                                        ...textareaContent,
                                        ...this.genQuestionDescription(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                default:
                                    break;
                            }
                        }
                        component = <AOForm.Textarea
                            content={textareaContent}
                            handleChange={this.valueDidChange}
                            handleBlurAction={this.onBlurAction}
                        />;
                        break;
                    }
                case 25: // MainGroupTitle
                    {
                        let content = {
                            title: questionTitle,
                            dataKey: questionIndicator,
                        };
                        if (hasHint) {
                            switch (hintStyleType) {
                                case 0: {
                                    content = {
                                        ...content,
                                        ...this.genQuestionMark(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                case 1: {
                                    content = {
                                        ...content,
                                        ...this.genQuestionDescription(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                default:
                                    break;
                            }
                        }
                        component = <AOForm.MainGroupTitle
                            content={content} />;
                        break;
                    }
                case 26: // SubGroupTitle
                    {
                        let content = {
                            title: questionTitle,
                            dataKey: questionIndicator,
                        };
                        if (hasHint) {
                            switch (hintStyleType) {
                                case 0: {
                                    content = {
                                        ...content,
                                        ...this.genQuestionMark(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                case 1: {
                                    content = {
                                        ...content,
                                        ...this.genQuestionDescription(questionIndicator, questionMarkDetail)
                                    };
                                    break;
                                }
                                default:
                                    break;
                            }
                        }
                        component = <AOForm.SubGroupTitle content={content} />;
                        break;
                    }
                case 28: //text only
                    {
                        const content = {
                            text: questionTitle,
                            dataKey: questionIndicator,
                        };
                        component = <AOForm.TextOnly content={content} />;
                        break; 
                    }
                default:
                    {
                        component = <Row>
                            <AOForm.MainGroupTitle
                                content={{
                                    title: questionTitle,
                                    dataKey: questionIndicator,
                                }}
                            /></Row>;
                        break;
                    }
            }

            component = this.handleSubQuestionCondition(app, obj, isDisable, component);
            return needContainer ? (
                <div className="form-item clearfix" key={questionIndicator} data-key={`${questionIndicator}-container`}>
                    {component}
                </div>
            ) : component;
        });
    };

    handleSubQuestionCondition = (app, obj, isDisable, component) => {
        if (checkSubQuestionCondition(app, obj)) {
            let subViews = null;
            let subWarning = null;
            const [firstQuestion,] = obj.subQuestions;
            const tempSubViews = this.handleGroupList(obj, isDisable);
            if (firstQuestion.answerType === 19) {
                if (tempSubViews.length && tempSubViews.length > 1) {
                    const [firstView, ...otherViews] = tempSubViews;
                    subWarning = firstView;
                    subViews = otherViews;
                } else {
                    subViews = tempSubViews;
                }
            } else {
                subViews = tempSubViews;
            }
            return (
                <div>
                    {component}
                    {/* <Row><AOForm.DividingLine /></Row>
                    {subViews}*/}
                    {subWarning && subWarning}

                    {subViews &&
                        <div className="form-sub-item">
                            {subViews}
                        </div>
                    }
                </div>
            )
        } else {
            return component
        }
    };

    handlePanelList = (obj, isDisable) => {
        const { subQuestions, questionLocales, questionId, questionStatus, index, questionIndicator } = obj;
        const { selectedLanguage, form_base_content } = this.props;
        const { currentOpenPanel } = this.state;
        let questionTitle = getContentByLocal(questionLocales, selectedLanguage);
        questionTitle += index === 1 ? '' : ' ' + index;

        const isOpen = currentOpenPanel ? currentOpenPanel === questionId || questionStatus === 0 : questionStatus === 0;
        let subViews = null;
        if (subQuestions && isOpen) {
            subViews = this.handleSubQuestion(subQuestions, isDisable);
        }

        const content = {
            isPanel: isOpen,
            isHandlePanel: isDisable,
            inedited: questionStatus === 0,
            panelTitle: {
                title: questionTitle,
                dataKey: `${questionIndicator}-title`
            },
            panelContinue: {
                title: form_base_content.continue,
                dataKey: `${questionIndicator}-continue`
            }
        };

        return (
            <div className={isOpen ? ' form-item clearfix' : 'form-item form-item-panel'} key={questionId}>
                <AOForm.PanelGroupForm
                    content={content}
                    handlePanelHead={this.handlePanelOpen}
                    handlePanelContinue={this.handlePanelContinue}
                    questionRel={obj}
                >
                    {subViews}
                </AOForm.PanelGroupForm>
            </div>)
    };

    handlePanelOpen = (obj) => {
        const { questionId } = obj;
        this.handlePanelChange(obj);
        this.setState({ currentOpenPanel: questionId })
    };

    getConPerCount = (info, value) => {
        let count = [];
        for (let item of info.ConPer) {
            if (item.CapOfConPar.includes(value)) {
                count.push(item);
            }
        }
        return count;
    };

    handleConPerInfo = (ConPer) => {
        const O = {};
        // 称谓
        O.LegRepTit = ConPer.ConPerTit;
        // 中文姓
        O.LegRepFamNameChi = ConPer.ConPerFamNamChi;
        // 中文名
        O.LegRepFirNameChi = ConPer.ConPerFirFamChi;
        // 英文姓
        O.LegRepFamNamEng = ConPer.ConPerFamNamEng;
        // 英文名
        O.LegRepFirNameEng = ConPer.ConPerFirFamEng;
        // 身份证文件种类
        O.LegRepIDType = ConPer.ConPerIDTyp.value;
        // 身份证明文件号码
        O.LegRepIDNum = ConPer.ConPerIDNum;
        // 出生日期
        O.LegRepDateOfBir = ConPer.ConPerDateOfBir;
        // 可选电话
        O.LegRepTelNumCountryCode = ConPer.ConPerOffTelNumCountryCode || '';
        O.LegRepTelNumAreCode = ConPer.ConPerOffTelNumAreCode || '';
        O.LegRepTelNumTel = ConPer.ConPerOffTelNumTel || '';
        O.LegRepTelNum = ConPer.ConPerOffTelNum || '';
        // 手机号码
        O.LegRegMobNumCountryCode = ConPer.ConPerMobNumCountryCode;
        O.LegRegMobNumTel = ConPer.ConPerMobNumTel;
        O.LegRegMobNum = ConPer.ConPerMobNum;
        return O;
    };

    // validate panel group, update panel status if completed, show error if not
    handlePanelContinue = (obj) => {
        this.handlePanelChange(obj);
        this.validatePanel(obj)
            .then(() => {
                const { saveAOForm, applicationInfo, countryListDatas, businessInfo } = this.props;
                const { currentSection } = this.state;
                const applicationInfoWithNewPanel = replaceQuestion(applicationInfo, { ...currentSection });
                const newApplicationInfo = replaceSubQuestion(applicationInfoWithNewPanel, { ...obj, questionStatus: 2 });
                // const newSection = findQuestionById(newApplicationInfo, "S003");

                const businessScope = handleFindAnswerbyQuestionIndicator(newApplicationInfo, 'BusinessScope'); // json里隐藏‘经营范围’的value
                const [flattenObj, panelStatusObj] = handleJsonToAnswer(newApplicationInfo, countryListDatas);
                flattenObj.BusinessScope = businessScope;

                if (this.state.id === 'Q003-007') {
                    let ConPer = [];
                    const { form_error_prompt } = this.state;
                    const s = form_error_prompt.errorInfo.includes('：') ? '：' : ':';
                    form_error_prompt.errorInfo = form_error_prompt.errorInfo.split(s)[0] + s;
                    const isLS = this.isSelectLS(flattenObj);
                    if (['SelfEmploy', 'PriOwn'].includes(businessInfo.qianHaiInfo.entityType.form)) {
                        ConPer = this.getConPerCount(flattenObj, 'SoleProprietor');
                        if (ConPer.length !== 1) {
                            form_error_prompt.errorInfo += form_error_prompt.errorInfo_SoleProprietor;
                            this.displayError(form_error_prompt);
                            return Promise.reject('SoleProprietor');
                        }
                        if(isLS){
                            form_error_prompt.errorInfo += form_error_prompt.errorInfo_LS;
                            this.displayError(form_error_prompt);
                            return Promise.reject('LS');
                        }
                    } else {
                        ConPer = this.getConPerCount(flattenObj, 'LegRepPerson');
                        if (ConPer.length !== 1) {
                            form_error_prompt.errorInfo += form_error_prompt.errorInfo_LegRepPerson;
                            this.displayError(form_error_prompt);
                            return Promise.reject('LegRepPerson');
                        }
                        if(isLS){
                            form_error_prompt.errorInfo += form_error_prompt.errorInfo_LS;
                            this.displayError(form_error_prompt);
                            return Promise.reject('LS');
                        }
                    }
                    const ConPerInfo = this.handleConPerInfo(ConPer[0]);
                    for (let key in ConPerInfo) {
                        flattenObj[key] = ConPerInfo[key];
                    }
                }

                this.changeTypeOfVTAanswer(flattenObj);
                return saveAOForm(newApplicationInfo,
                    flattenObj,
                    panelStatusObj,
                    businessInfo.qianHaiInfo)
            })
            .then(() => {
                this.setState({ currentOpenPanel: null, isShowError: false });
            })
            .catch(error => {
                const { form_error_prompt } = this.state;
                const s = form_error_prompt.errorInfo.includes('：') ? '：' : ':';
                form_error_prompt.errorInfo = form_error_prompt.errorInfo.split(s)[0] + s;
                if (Array.isArray(error)) {
                    this.setState({
                        isShowError: true,
                        form_error_prompt: form_error_prompt
                    }, () => {
                        this.scrollToTop()
                    })
                }
            });
    };

    isSelectLS = (info) => { // 判断关联方里是否同时存在LegRepPerson & SoleProprietor
        let isLS = false;
        let LegRepPersonCount = [];
        let SoleProprietorCount = [];
        for (let item of info.ConPer) {
            if (item.CapOfConPar.includes("LegRepPerson")) {
                LegRepPersonCount.push(item);
            }
            if (item.CapOfConPar.includes("SoleProprietor")) {
                SoleProprietorCount.push(item);
            }
        }
        if(LegRepPersonCount.length >= 1 && SoleProprietorCount.length >= 1) {
            isLS = true;
        }
        return isLS;
    };

    displayError = (errInfo) => {
        this.setState({
            isShowError: true,
            form_error_prompt: errInfo
        }, () => {
            this.scrollToTop()
        })
    }

    // check other panels' question, if completed panel has error, change its questionStatus to incomplete
    handlePanelChange = (obj) => {
        const { currentSection } = this.state;
        const { applicationInfo } = this.props;
        const app = replaceQuestion(applicationInfo, currentSection);
        currentSection.subQuestions.forEach(question => {
            const shouldDisplay = aoformQuestionShouldDisplay(app, question);
            shouldDisplay && question.subQuestions && question.subQuestions.forEach(subQuestion => {
                if (!(obj && obj.questionId === subQuestion.questionId)) {
                    this.validatePanel(subQuestion)
                        .catch(error => {
                        });
                }
            })
        });
        const { errorList } = this.state;
        if (errorList && errorList.length > 0) {
            errorList.forEach(errorQuestion => {
                currentSection.subQuestions.forEach(question => {
                    question.subQuestions && question.subQuestions.forEach(subQuestion => {
                        if (isSubQuestionWithinQuestion(subQuestion, errorQuestion)) {
                            if (subQuestion.questionStatus !== 0) {
                                subQuestion.questionStatus = 0
                            }
                        }
                    })
                });
            });
        }
        this.setState({ currentSection })
    };

    handleRegionProportional = (obj, isDisable) => {
        const { subQuestions, index } = obj;
        const { selectedLanguage, form_base_content, applicationInfo, countryListDatas } = this.props;
        const { errorList, errorMsgs, currentSection } = this.state;
        // const questionTitle = getContentByLocal(questionLocales, selectedLanguage);
        const [region, ...inputQuestions] = subQuestions;
        let regionContent = null;
        if (region) {
            const { questionLocales, answers, userAnswer, questionId, questionIndicator, answerType } = region;
            let questionTitle = getContentByLocal(questionLocales, selectedLanguage);
            questionTitle += index === 1 ? '' : ' ' + index;
            const isError = errorList.indexOf(questionId) !== -1;
            const errorMsg = errorMsgs[questionId];
            let answerOptions = null;
            if (answerType === 5) {
                const app = replaceQuestion(applicationInfo, currentSection);
                answerOptions = answers && answers.filter(answer => {
                    return aoformAnswerShouldDisplay(app, answer)
                }).map(item => {
                    return {
                        id: item.answerId,
                        text: getContentByLocal(item.answerLocales, selectedLanguage),
                        dataKey: item.answerIndicator
                    }
                });
            } else if (answerType === 27) {
                const baseAnswerId = questionId.replace('Q', 'A') + ":";

                answerOptions = countryListDatas && countryListDatas.map((item, index) => {
                    const answerId = baseAnswerId + fix(index + 1)
                    return {
                        id: answerId,
                        text: getContentByLocal(item.leveLocales, selectedLanguage),
                        dataKey: `${questionIndicator}_${item.indicator}`
                    }
                });
            }

            if (answerOptions) {
                answerOptions = [{ id: "", 'text': form_base_content.drop_down_list_place_holder }, ...answerOptions];
            }
            let defaultValue = null;
            if (userAnswer) {
                defaultValue = userAnswer.chosenAnswerId
                let include = false;
                for (let i = 0; i < answerOptions.length; i++) {
                    if (answerOptions[i].id === defaultValue) {
                        include = true;
                        break;
                    }
                }
                if (!include) {
                    this.setUserAnswer(region, '')
                    defaultValue = ''
                }
            } else {
                const app = replaceQuestion(applicationInfo, currentSection);
                defaultValue = this.handleDefaultValue(app, obj)
            }
            regionContent = {
                itemTitle: {
                    text: questionTitle,
                    dataKey: `${questionIndicator}-subtitle`
                },
                validatedTips: isError ? errorMsg : '',
                selectOptions: answerOptions,
                defaultValue: defaultValue,
                questionRel: region,
                dataKey: questionIndicator,
                isDisabled: isDisable,
                isError
            };
        }

        const inputFields = inputQuestions.map(item => {
            const { questionLocales, userAnswer, questionId, questionIndicator } = item;
            const isError = errorList.indexOf(questionId) !== -1;
            const errorMsg = errorMsgs[questionId];
            const questionTitle = getContentByLocal(questionLocales, selectedLanguage);
            let defaultValue = null;
            if (userAnswer) {
                defaultValue = getInputContent(userAnswer)
            } else {
                const app = replaceQuestion(applicationInfo, currentSection);
                defaultValue = this.handleDefaultValue(app, obj)
            }
            return {
                textValue: defaultValue,
                subtitle: {
                    title: questionTitle,
                    dataKey: `${questionIndicator}-subtitle`,
                },
                isError: isError,
                errorMessage: errorMsg,
                isDisabled: isDisable,
                questionRel: item,
                dataKey: questionIndicator
            }
        });
        const content = {
            selectField: regionContent,
            inputField: inputFields
        };
        return (
            <AOForm.Region
                onChangeAction={this.valueDidChange}
                handleBlurAction={this.onBlurAction}
                content={content}
            />
        );
    };

    handleGroupList = (obj, isDisable) => {
        const { subQuestions } = obj;
        if (subQuestions) {
            return this.handleSubQuestion(subQuestions, isDisable);
        } else {
            return null;
        }
    };

    handleRepeatGroup = (obj, isDisable, hasHint, hintStyleType, questionMarkDetail) => {
        const { subQuestions, questionLocales, condition } = obj;

        const { selectedLanguage, form_base_content } = this.props;
        const questionTitle = getContentByLocal(questionLocales, selectedLanguage);
        let titleContent = { title: questionTitle, dataKey: 'CombinedGroup' }
        if (hasHint) {
            switch (hintStyleType) {
                case 0: {
                    titleContent = {
                        ...this.genQuestionMark('CombinedGroup', questionMarkDetail),
                        ...titleContent
                    }
                    break;
                }
                case 1: {
                    titleContent = {
                        ...this.genQuestionDescription('CombinedGroup', questionMarkDetail),
                        ...titleContent
                    }
                    break;
                }
                default:
                    break;
            }

        }
        const questions = this.handleSubQuestion(subQuestions, isDisable);
        let repeatMax = null, addButtonTitle = null;
        const conditionObj = condition && JSON.parse(condition);
        if (conditionObj) {
            repeatMax = conditionObj.repeatMax;
            addButtonTitle = conditionObj.addButtonTitle && getContentByLocal(conditionObj.addButtonTitle, selectedLanguage);
        }
        return (
            <AOForm.CombinedGroup
                itemArray={subQuestions}
                onDelAction={this.repeatGroupDelAction}
                onAddAction={this.repeatGroupAddAction}
                onChangeAction={this.combinedGroupOnChangeAction}
                addBtnText={{ text: addButtonTitle, dataKey: 'addValue' }}
                removeBtnText={{ text: form_base_content.remove, dataKey: 'removeItem' }}
                titleContent={titleContent}
                questionRel={obj}
                repeatMax={repeatMax}
            >
                {questions}
            </AOForm.CombinedGroup>
        )
    };

    handleResOrBusOpeSitCodeLevelSelectGroup = (obj) => {
        const { subQuestions } = obj;
        if (subQuestions) {
            return this.handleSubQuestion(subQuestions[0].subQuestions);
        } else {
            return null;
        }
    };

    handleSelectGroup = (obj) => {
        const { subQuestions, questionLocales, condition } = obj;
        const { selectedLanguage, form_base_content, applicationInfo, countryListDatas } = this.props;
        const questionTitle = getContentByLocal(questionLocales, selectedLanguage);
        const { errorList, errorMsgs, currentSection } = this.state;
        
        let itemArray = [];
        if (subQuestions) {
            itemArray = itemArray.concat(subQuestions.map((subQuestion, index) => {
                const { questionLocales, userAnswer, questionId, answerType, questionIndicator, hide } = subQuestion;
                const isError = errorList.indexOf(questionId) !== -1;
                const errorMsg = errorMsgs[questionId];
                const itemTitle = {
                    text: `${getContentByLocal(questionLocales, selectedLanguage)}`,
                    dataKey: index
                };
                let selectOptions = null
                if (answerType === 5) {
                    const app = replaceQuestion(applicationInfo, currentSection);
                    selectOptions = subQuestion.answers.filter(answer => {
                        return aoformAnswerShouldDisplay(app, answer)
                    }).map(answer => {
                        return {
                            id: answer.answerId,
                            text: getContentByLocal(answer.answerLocales, selectedLanguage),
                            dataKey: answer.answerIndicator
                        }
                    });
                } else if (answerType === 27) {
                    const baseAnswerId = questionId.replace('Q', 'A') + ":"

                    selectOptions = countryListDatas && countryListDatas.map((item, index) => {
                        const answerId = baseAnswerId + fix(index + 1)
                        return {
                            id: answerId,
                            text: getContentByLocal(item.leveLocales, selectedLanguage),
                            dataKey: `${questionIndicator}_${item.indicator}`
                        }
                    });
                }

                if (selectOptions) {
                    selectOptions = [{ id: "", 'text': form_base_content.drop_down_list_place_holder }, ...selectOptions];
                }
                let defaultValue = null;
                if (userAnswer) {
                    defaultValue = userAnswer.chosenAnswerId
                    let include = false;
                    for (let i = 0; i < selectOptions.length; i++) {
                        if (selectOptions[i].id === defaultValue) {
                            include = true;
                            break;
                        }
                    }
                    if (!include) {
                        this.setUserAnswer(subQuestion, '')
                        defaultValue = ''
                    }
                } else {
                    const app = replaceQuestion(applicationInfo, currentSection);
                    defaultValue = this.handleDefaultValue(app, subQuestion)
                }
                return {
                    itemTitle: itemTitle,
                    questionMark: null,
                    validatedTips: errorMsg,
                    placeHolder: form_base_content.drop_down_list_place_holder,
                    defaultValue: defaultValue,
                    selectOptions: selectOptions,
                    dataKey: questionIndicator,
                    questionRel: subQuestion,
                    isError: isError
                }
            }))
        }
        let repeatMax = null, addButtonTitle = null;
        const conditionObj = condition && JSON.parse(condition);
        if (conditionObj) {
            repeatMax = conditionObj.repeatMax;
            addButtonTitle = conditionObj.addButtonTitle && getContentByLocal(conditionObj.addButtonTitle, selectedLanguage);
        }
        return <AOForm.SelectGroup
            itemArray={itemArray}
            onChangeAction={this.valueDidChange}
            onDelAction={this.repeatGroupDelAction}
            onAddAction={this.repeatGroupAddAction}
            addBtnText={{ text: addButtonTitle, dataKey: 'addValue' }}
            questionRel={obj}
            content={{ title: questionTitle, dataKey: 'selectGroup' }}
            removeText={form_base_content.remove}
            repeatMax={repeatMax}
        />
    };

    handleEmailGroup = (obj, isDisable) => {
        const { subQuestions, condition, questionLocales } = obj;
        const { selectedLanguage, form_base_content, applicationInfo } = this.props;
        const { errorList, errorMsgs, currentSection } = this.state;
        const questionTitle = getContentByLocal(questionLocales, selectedLanguage);

        let emailGroupContent = null;
        if (subQuestions) {
            emailGroupContent = subQuestions.map(subQuestion => {
                const { userAnswer, questionLocales, questionId } = subQuestion;
                const questionTitle = getContentByLocal(questionLocales, selectedLanguage);
                const isError = errorList.indexOf(questionId) !== -1;
                const errorMsg = errorMsgs[questionId];
                let defaultValue = "";
                if (userAnswer) {
                    defaultValue = getInputContent(userAnswer)
                } else {
                    const app = replaceQuestion(applicationInfo, currentSection);
                    defaultValue = this.handleDefaultValue(app, subQuestion)
                }
                return {
                    textValue: defaultValue,
                    subtitle: {
                        title: questionTitle,
                        dataKey: subQuestion.questionIndicator
                    },
                    placeholder: '',
                    isError: isError,
                    errorMessage: errorMsg,
                    isDisabled: isDisable,
                    questionMark: null,
                    questionRel: subQuestion,
                    dataKey: subQuestion.questionIndicator
                }
            })
        }
        let repeatMax = null, addButtonTitle = null;
        const conditionObj = condition && JSON.parse(condition);
        if (conditionObj) {
            repeatMax = conditionObj.repeatMax;
            addButtonTitle = conditionObj.addButtonTitle && getContentByLocal(conditionObj.addButtonTitle, selectedLanguage);
        }
        return <AOForm.EmailGroup
            itemArray={emailGroupContent}
            onChangeAction={this.valueDidChange}
            handleBlurAction={this.onBlurAction}
            onDelAction={this.repeatGroupDelAction}
            onAddAction={this.repeatGroupAddAction}
            addBtnText={{ text: addButtonTitle, dataKey: 'addValue' }}
            questionRel={obj}
            removeText={form_base_content.remove}
            content={{ title: questionTitle, dataKey: 'emailGroup' }}
            repeatMax={repeatMax}
        />
    };

    // repeat add / delete logic
    repeatGroupDelAction = (questionRel, deleteIndex) => {
        const { currentSection, errorList } = this.state;
        const { subQuestions } = questionRel;
        const isPanel = isConnectedParties(questionRel, true);
        if (subQuestions && subQuestions.length > 1) {
            // empty error list first
            let tempErrorList = errorList;
            tempErrorList.splice(0, tempErrorList.length);
            subQuestions.splice(deleteIndex, 1);
            regenSubQuestionId(questionRel);

            if (isPanel) {
                this.validatePanelGroup(questionRel)
                    .then(() => {
                        this.setState({
                            currentSection,
                            errorList: tempErrorList,
                            currentOpenPanel: null,
                            isShowError: false
                        })
                    })
                    .catch(error => {
                        if (Array.isArray(error)) {
                            this.setState({
                                isShowError: true
                            }, () => {
                                this.scrollToTop()
                            })
                        }
                    })

            } else {
                this.setState({ currentSection, errorList: tempErrorList });
            }
        }
    };

    repeatGroupAddAction = (questionRel) => {
        const isPanel = isConnectedParties(questionRel, true);
        if (isPanel) {
            /*
             * validate all panel first,
             * if all passed, change panel's question status and add panel group then call save api,
             * if not, alert error
             */
            this.validatePanelGroup(questionRel)
                .then(() => {
                    const { saveAOForm, applicationInfo, countryListDatas, businessInfo } = this.props;
                    const { currentSection, currentOpenPanel } = this.state;
                    const applicationInfoWithNewPanel = replaceQuestion(applicationInfo, { ...currentSection });
                    let newApplicationInfo = null;
                    questionRel.subQuestions.forEach(question => {
                        newApplicationInfo = replaceSubQuestion(applicationInfoWithNewPanel, { ...question, questionStatus: 2 });
                    });
                    
                    const { subQuestions } = questionRel;
                    const newQuestion = cloneQuestion(subQuestions[0]);
                    questionRel.subQuestions.push(newQuestion);
                    regenSubQuestionId(questionRel);
                    if (currentOpenPanel || subQuestions[0].questionStatus === 0) {
                        for (let i = 0; i < subQuestions.length - 1; i++) {
                            subQuestions[i].questionStatus = 2
                        }
                        const newApplicationInfoWithNewPanel = replaceQuestion(newApplicationInfo, { ...currentSection });

                        const businessScope = handleFindAnswerbyQuestionIndicator(newApplicationInfoWithNewPanel, 'BusinessScope'); // json里隐藏‘经营范围’的value
                        const [flattenObj, panelStatusObj] = handleJsonToAnswer(newApplicationInfoWithNewPanel, countryListDatas);
                        flattenObj.BusinessScope = businessScope;

                        this.changeTypeOfVTAanswer(flattenObj);
                        saveAOForm(newApplicationInfoWithNewPanel,
                            flattenObj,
                            panelStatusObj,
                            businessInfo.qianHaiInfo);
                        this.setState({ nextOpenPanel: newQuestion.questionId })
                    } else {
                        this.setState({ currentOpenPanel: newQuestion.questionId, currentSection })
                    }
                })
                .catch(error => {
                    if (Array.isArray(error)) {
                        this.setState({
                            isShowError: true
                        }, () => {
                            this.scrollToTop()
                        })
                    }
                });
        } else {
            const { currentSection } = this.state;
            const { subQuestions } = questionRel;
            if (subQuestions && subQuestions.length > 0) {
                const newQuestion = cloneQuestion(subQuestions[0]);
                questionRel.subQuestions.push(newQuestion);
                regenSubQuestionId(questionRel);
                this.setState({ currentSection })
            }
        }
    };

    // handle value did change
    valueDidChange = (questionRel, value) => {
        
        const { errorList } = this.state;
        // const { applicationInfo, form_base_content, selectedLanguage } = this.props;
        const { questionId, condition } = questionRel;
        const conditionObj = condition && JSON.parse(condition);
        this.setUserAnswer(questionRel, value);
        let duplicateList = null
        if (questionRel.questionId === 'Q003-004-003') {
            if (questionRel.userAnswer && questionRel.userAnswer.chosenAnswerId) {
                const { currentSection } = this.state;
                const targetQuestion = findQuestionByIdInSubSection(currentSection, 'Q003-004-006');
                if (questionRel.userAnswer.chosenAnswerId === 'A003-004-003:004') {
                    this.setUserAnswer(targetQuestion, 'A003-004-006:001');
                } else {
                    targetQuestion.userAnswer = null;
                }
            }
        } else if (questionRel.questionIndicator === 'CountryBusinessIsSubToTaxRes') {
            const { currentSection } = this.state;
            duplicateList = checkDuplicateByQuestionIndicator(currentSection, questionRel.questionIndicator)
        } else if (conditionObj && conditionObj.errorCondition) {
            aoformValidationErrorCondition(questionRel, errorList)
        } else if(questionRel.questionId === 'Q003-006-005' || questionRel.questionId === 'Q003-006-006'){
            const { currentSection } = this.state;
            const targetQuestion = findQuestionByIdInSubSection(currentSection, questionRel.questionId);
            this.setUserAnswer(targetQuestion, chineseCharacterAndMark(value));
         }
        const itemIndex = errorList.indexOf(questionId);
        if (itemIndex !== -1) {
            errorList.splice(itemIndex, 1);
        }
        if (duplicateList !== null) {
            const { errorMsgs } = this.state;
            const { form_base_content } = this.props;
            duplicateList.forEach((value) => {
                if (errorList.indexOf(value) === -1) {
                    errorMsgs[value] = form_base_content.same_country_error
                    errorList.push(value)
                }
            })
        }
        this.setState({
            errorList
        });
    };
    // handling for birthday 
    handleForOtherCondition = (app, questionRel, isError) => {
        const { condition, userAnswer } = questionRel;
        const { currentSection, errorList, errorMsgs, form_error_prompt } = this.state;
        const conditionObj = condition && JSON.parse(condition);
        // handle For Birthday
        if (!isError && conditionObj && conditionObj.handleCondition) {
            if (conditionObj.validations && conditionObj.validations.length > 0 && isAOFormConditionMatch(app, conditionObj.validations[0].condition, questionRel, false)) {
                const userAnswerTmp = userAnswer.contents[0];
                let handleConditionObj = conditionObj.handleCondition;

                if (handleConditionObj.type === "getBirthday") {
                    if (handleConditionObj.questionId.indexOf('*') !== -1) { 
                        handleConditionObj = handleIdTemplate({}, handleConditionObj, questionRel)
                    }
                    const targetId = handleConditionObj.questionId;
                    const targetQuestion = findQuestionByIdInSubSection(currentSection, targetId);
                    const birth = userAnswerTmp.substring(12, 14) + "-" + userAnswerTmp.substring(10, 12) + "-" + userAnswerTmp.substring(6, 10);
                    const index = errorList.indexOf(targetId);
                    if (index !== -1) {
                        errorList.splice(index, 1);
                    }
                    this.setUserAnswer(targetQuestion, birth);
                    this.setState({
                        errorList
                    });
                }
            }
        }
        // 鼠标离开时 handle For mobile 格式：国家/地区代码 + 电话号码
        if(conditionObj && conditionObj.handleMobile && currentSection && questionRel.questionId) {
            // get mobile id
            const sonId = questionRel.questionId; // eg: Q003-006-015-001-001-009-001  or Q003-006-015-001-001-009-002
            const fatherId= sonId && sonId.slice(0,sonId.length - 4); // eg: Q003-006-015-001-001-009
            const fatherSection = findQuestionByIdInSubSection(currentSection, fatherId);
            let regionCode = ""; // 国家/地区代码
            let mobileNumber = ""; // 电话号码
            if(fatherSection) {
               const userAnswerTmp = fatherSection.userAnswer && fatherSection.userAnswer.contents[0];
               if(userAnswerTmp) {
                    regionCode = userAnswerTmp.split("-")[0];
                    mobileNumber = userAnswerTmp.split("-")[1];
               }
            }
            if(["86","086","+86"].indexOf(regionCode) > -1) {
                if(mobileNumber.length !=11){
                    errorList.push(fatherId);
                    errorMsgs[fatherId] = form_error_prompt.errorInfo_Mobile11Digits;
                } else {
                    const index = errorList.indexOf(fatherId);
                    if (index !== -1) {
                        errorList.splice(index, 1);
                    }
                }
                this.setState({
                    errorList,
                    errorMsgs
                });
            }
            if(["852"].indexOf(regionCode) > -1) {
                if(mobileNumber.length !=8){
                    errorList.push(fatherId);
                    errorMsgs[fatherId] = form_error_prompt.errorInfo_Mobile8Digits;
                } else {
                    const index = errorList.indexOf(fatherId);
                    if (index !== -1) {
                        errorList.splice(index, 1);
                    }
                }
                this.setState({
                    errorList,
                    errorMsgs
                });
            }            
        }        
    }
    
    onBlurAction = (questionRel) => {
        let needUpdateState = false;
        const { currentSection, errorList, errorMsgs } = this.state;
        const { applicationInfo, form_base_content, selectedLanguage, businessInfo, countryListDatas } = this.props;
        const { questionId, answerType } = questionRel;
        const app = replaceQuestion(applicationInfo, currentSection);
        let tempError = false;
        let tempErrorMsg = null;
        let duplicateList = null;
        const [isError, errorMsg] = validationQuestion(app, questionRel, form_base_content, selectedLanguage, businessInfo, countryListDatas);
        tempError = isError;
        tempErrorMsg = errorMsg;
        switch (answerType) {
            case 4: {
                this.handleForOtherCondition(app, questionRel, tempError);
                break;
            }
            default: {
                break;
            }
        }
        //handling for 003-005
        if (questionRel.questionIndicator === 'EmailAddSta') {
            duplicateList = checkDuplicateByQuestionIndicator(currentSection, questionRel.questionIndicator)
        }
        const itemIndex = errorList.indexOf(questionId);
        if (tempError) {
            if (itemIndex === -1) {
                errorList.push(questionId);
                needUpdateState = true;
            }
            errorMsgs[questionId] = tempErrorMsg;
        } else {
            if (itemIndex !== -1) {
                errorList.splice(itemIndex, 1);
                needUpdateState = true;
            }
        }
        if (duplicateList !== null) {
            const { form_base_content } = this.props;
            duplicateList.forEach((value) => {
                if (errorList.indexOf(value) === -1) {
                    errorMsgs[value] = form_base_content.same_email
                    errorList.push(value);
                    needUpdateState = true;
                }
            })
        }
        if (needUpdateState) {
            if (this.timeout) {
                clearTimeout(this.timeout)
            }
            this.timeout = setTimeout(() => {
                try {
                    this.setState({
                        errorList
                    });
                } catch (error) {

                }
            }, 200)
        }
    };

    setUserAnswer = (question, value) => {
        switch (question.answerType) {
            case 1: // Radio button
            case 5: // DropdownList
            case 27: // CountryList
                question.userAnswer = { chosenAnswerId: value };
                break;
            case 110:
                question.userAnswer = { chosenAnswerId: value };
                if(value !== "" || value !== null || value !== undefined){
                    this.cascadingDropDownLogicHandlerNew(question,value)
                }
                break;
            case 2: // Check box
                let tempValue = value;
                if (!isArray(value)) {
                    tempValue = [value];
                }
                question.userAnswer = { chosenAnswerId: tempValue.join() };
                break;
            case 4: // Input
            case 21: // InputDigit
            case 24: // TextArea
            case 23: // InputPercentage
                question.userAnswer = { contents: [value] };
                break;
            case 7:
            case 8:
                question.userAnswer = { contents: [value] };
                const answers = (value || "--").split('-');
                question.subQuestions && question.subQuestions.forEach((subQuestion, index) => {
                    this.setUserAnswer(subQuestion, answers[index])
                });
                break;
            case 16: // DateInput
                question.userAnswer = { contents: [value] };
                break;
            default:
                break;
        }
    };

    clearTimeoutAction = () => {
        if (this.timeout) {
            clearTimeout(this.timeout)
        }
    }

    // Validation
    validateForm = (showError = true) => {
        this.clearTimeoutAction()
        return new Promise((resolve, reject) => {
            const { currentSection } = this.state;
            let tempErrorList = [];
            const { subQuestions } = currentSection;
            this.validateSubQuestion(subQuestions, tempErrorList);
            if (showError) {
                this.setState({
                    errorList: tempErrorList
                }, () => {
                    const { errorList } = this.state;
                    if (errorList && errorList.length > 0) {
                        // new Error(`validation error > ${errorList}`)
                        let statusChange = 0;
                        isConnectedParties(currentSection) && currentSection.subQuestions.forEach(question => {
                            question.subQuestions && question.subQuestions.forEach(subQuestion => {
                                errorList.forEach(errorQuestion => {
                                    if (isSubQuestionWithinQuestion(subQuestion, errorQuestion)) {
                                        if (subQuestion.questionStatus === 2) {
                                            subQuestion.questionStatus = 0;
                                            statusChange++
                                        }
                                    }
                                })
                            })
                        });
                        if (statusChange > 0) {
                            this.setState({ currentSection: currentSection})
                        }
                        reject && reject(errorList)
                    } else {
                        // console.log("resolve > ", errorList)
                        resolve && resolve()
                    }
                });
            } else {
                if (tempErrorList && tempErrorList.length > 0) {
                    reject && reject(tempErrorList)
                } else {
                    resolve && resolve()
                }
            }
        });
    };

    validateAndUpdateConnectedParties = (currentSection) => {
        currentSection.subQuestions.forEach(question => {
            question.subQuestions && question.subQuestions.forEach(subQuestion => {
                let tempErrorList = [];
                this.validateSubQuestion(subQuestion.subQuestions, tempErrorList);
                if (tempErrorList.length > 0 && subQuestion.questionStatus !== 0) {
                    subQuestion.questionStatus = 0
                } else if (tempErrorList.length === 0 && subQuestion.questionStatus !== 2) {
                    subQuestion.questionStatus = 2
                }
            })
        });
        return currentSection
    };

    // validate panel question first, if current panel has error, reject it, else resolve
    validatePanel = (obj) => {
        this.clearTimeoutAction()
        return new Promise((resolve, reject) => {
            let tempErrorList = [];
            this.validateSubQuestion(obj.subQuestions, tempErrorList);
            this.setState({
                errorList: tempErrorList
            }, () => {
                const { errorList } = this.state;
                if (errorList && errorList.length > 0) {
                    let errorFromCurrentPanelFlag = 0;
                    errorList.forEach(errorQuestion => {
                        if (isSubQuestionWithinQuestion(obj, errorQuestion)) {
                            errorFromCurrentPanelFlag++;
                        }
                    });
                    errorFromCurrentPanelFlag > 0 ? reject && reject(errorList) : resolve && resolve()
                } else {
                    // console.log("resolve > ", errorList)
                    resolve && resolve()
                }
            });
        })
    };

    // validate each group's completion and return completion result
    validatePanelGroup = (obj) => {
        this.clearTimeoutAction()
        return new Promise((resolve, reject) => {
            const { currentSection } = this.state;
            const { applicationInfo } = this.props;
            const app = replaceQuestion(applicationInfo, currentSection);
            let tempErrorList = [];
            let errorPanelGroupFlag = 0;
            obj.subQuestions.forEach(question => {
                // handle panel change for each panel
                const shouldDisplay = aoformQuestionShouldDisplay(app, question);
                shouldDisplay && question.subQuestions && this.validateSubQuestion(question.subQuestions, tempErrorList);
                if (tempErrorList && tempErrorList.length > 0) {
                    tempErrorList.forEach(errorQuestion => {
                        if (isSubQuestionWithinQuestion(question, errorQuestion)) {
                            errorPanelGroupFlag++;
                        }
                    });
                }
            });
            this.setState({
                currentSection,
                errorList: tempErrorList,
                isShowError: false
            }, () => {
                errorPanelGroupFlag > 0 ? reject && reject(tempErrorList) : resolve && resolve()
            });

        })
    };

    validateSubQuestion = (subQuestions, errorList) => {

        const { applicationInfo, form_base_content, selectedLanguage, businessInfo, countryListDatas } = this.props;
        const { currentSection, errorMsgs } = this.state;
        const app = replaceQuestion(applicationInfo, currentSection);

        // const requireErrorMsg = form_base_content.error_msg;
        const removeFormErrorList = (errorList, id) => {
            const index = errorList.indexOf(id);
            if (index !== -1) {
                errorList.splice(index, 1);
            }
        };

        const addError = (errorList, errorItem) => {
            const index = errorList.indexOf(errorItem);
            if (index === -1) {
                errorList.push(errorItem);
            }
        };

        subQuestions && subQuestions.forEach(question => {
            const shouldDisplay = aoformQuestionShouldDisplay(app, question);
            const {
                questionId,
                answerType,
                subQuestions,
                condition
            } = question;
            // const itemIndex = errorList.indexOf(questionId);
            if (!shouldDisplay) {
                removeFormErrorList(errorList, questionId);
                return;
            }
            const [isError, errorMsg] = validationQuestion(app, question, form_base_content, selectedLanguage, businessInfo, countryListDatas);
            // const itemIndex = errorList.indexOf(questionId);
            if (isError) {
                addError(errorList, questionId);
                errorMsgs[questionId] = errorMsg;
                // if (itemIndex !== -1) {
                // errorList.push(questionId);
                // }
            } else {
                if (errorMsg !== null && errorMsg !== form_base_content.error_msg && errorList.indexOf(questionId) !== -1) {

                } else {
                    removeFormErrorList(errorList, questionId)
                }
                // removeFormErrorList(errorList, questionId)
                // if (itemIndex !== -1) {
                //     errorList.splice(itemIndex, 1);
                // }
            }

            let isSkip = false;
            switch (answerType) {
                case 13: // RegionProportional
                    {
                        const [region, ...inputQuestions] = subQuestions;
                        const [isError, errorMsg] = validationQuestion(app, region, form_base_content, selectedLanguage, businessInfo, countryListDatas);
                        if (isError) {
                            addError(errorList, region.questionId);
                            errorMsgs[region.questionId] = errorMsg;
                        } else {
                            removeFormErrorList(errorList, region.questionId)
                        }
                        inputQuestions.forEach(tempQuestion => {
                            const [isError, errorMsg] = validationQuestion(app, tempQuestion, form_base_content, selectedLanguage, businessInfo, countryListDatas);
                            if (isError) {
                                addError(errorList, tempQuestion.questionId);
                                errorMsgs[tempQuestion.questionId] = errorMsg;
                            } else {
                                const errorMsg = errorMsgs[tempQuestion.questionId];
                                if (errorMsg !== null && errorMsg !== form_base_content.error_msg && errorList.indexOf(tempQuestion.questionId) !== -1) {

                                } else {
                                    removeFormErrorList(errorList, tempQuestion.questionId)
                                }
                            }
                        });
                        break;
                    }
                case 17: // SelectGroup
                case 18: // EmailGroup
                case 22: // PanelGroup
                    {
                        subQuestions && this.validateSubQuestion(subQuestions, errorList);
                        isSkip = true;
                        break;
                    }
                case 14: // Repeat Group
                    {
                        const conditionObj = condition && JSON.parse(condition);
                        if (conditionObj && conditionObj.validations) {
                            const { validations } = conditionObj;
                            validations && validations.forEach(validation => {
                                switch (validation.type) {
                                    // case 1: // revenuePercentage
                                    case 2: // sumRevenuePercentage
                                        {
                                            let [sum, subQuestionList] = checkPercentage(app, question, 1);

                                            if (sum > 100) {
                                                const errorMsg = validation.errorLocales && getContentByLocal(validation.errorLocales, selectedLanguage);
                                                subQuestionList.forEach(id => {
                                                    addError(errorList, id);
                                                    errorMsgs[id] = errorMsg;
                                                })
                                            } else {
                                                subQuestionList.forEach(id => {
                                                    removeFormErrorList(errorList, id)
                                                })

                                            }
                                            break;
                                        }
                                    // case 3: // purchasesPercentage
                                    case 4: // sumPurchasesPercentage
                                        {
                                            let [sum, subQuestionList] = checkPercentage(app, question, 3);
                                            // console.log(3, "percentage > ", sum)
                                            if (sum > 100) {
                                                const errorMsg = validation.errorLocales && getContentByLocal(validation.errorLocales, selectedLanguage);
                                                subQuestionList.forEach(id => {
                                                    addError(errorList, id);
                                                    errorMsgs[id] = errorMsg;
                                                })
                                            } else {
                                                subQuestionList.forEach(id => {
                                                    removeFormErrorList(errorList, id)
                                                })

                                            }
                                            break;
                                        }
                                    // case 5: // assetsPercentage
                                    case 6: // sumAssetsPercentage
                                        {
                                            let [sum, subQuestionList] = checkPercentage(app, question, 5);
                                            // console.log(5, "percentage > ", sum)
                                            if (sum > 100) {
                                                const errorMsg = validation.errorLocales && getContentByLocal(validation.errorLocales, selectedLanguage);
                                                subQuestionList.forEach(id => {
                                                    addError(errorList, id);
                                                    errorMsgs[id] = errorMsg;
                                                })
                                            } else {
                                                subQuestionList.forEach(id => {
                                                    removeFormErrorList(errorList, id)
                                                })

                                            }
                                            break;
                                        }
                                    // case 7: // ownershipPercentage
                                    case 8: // sumOwnershipPercentage
                                        {
                                            let [sum, subQuestionList] = checkPercentage(app, question, 7);
                                            // console.log(7, "percentage > ", sum)
                                            if (sum > 100) {
                                                const errorMsg = validation.errorLocales && getContentByLocal(validation.errorLocales, selectedLanguage);
                                                subQuestionList.forEach(id => {
                                                    addError(errorList, id);
                                                    errorMsgs[id] = errorMsg;
                                                })
                                            } else {
                                                subQuestionList.forEach(id => {
                                                    removeFormErrorList(errorList, id)
                                                })

                                            }
                                            break;
                                        }
                                    // case 9: // votingRightPercentage
                                    case 10: // sumVotingRightPercentage
                                        {
                                            let [sum, subQuestionList] = checkPercentage(app, question, 9);
                                            // console.log(9, "percentage > ", sum)
                                            if (sum > 100) {
                                                const errorMsg = validation.errorLocales && getContentByLocal(validation.errorLocales, selectedLanguage);
                                                subQuestionList.forEach(id => {
                                                    addError(errorList, id);
                                                    errorMsgs[id] = errorMsg;
                                                })
                                            } else {
                                                subQuestionList.forEach(id => {
                                                    removeFormErrorList(errorList, id)
                                                })

                                            }
                                            break;
                                        }
                                    default:
                                        break;
                                }
                            })
                        }
                        subQuestions && this.validateSubQuestion(subQuestions, errorList);
                        isSkip = true;
                        break;
                    }
                default:
                    {
                        break;
                    }
            }

            if (!isSkip) {
                if (checkSubQuestionCondition(app, question)) {
                    subQuestions && this.validateSubQuestion(subQuestions, errorList)
                }
            }
        });

        if (this.props.match.params.id === 'Q003-005') {
            const duplicateList = checkDuplicateByQuestionIndicator(currentSection, 'CountryBusinessIsSubToTaxRes')
            duplicateList.forEach((value) => {
                addError(errorList, value)
                errorMsgs[value] = form_base_content.same_country_error
            })
        } else if (this.props.match.params.id === 'Q003-003') {
            const duplicateList = checkDuplicateByQuestionIndicator(currentSection, 'EmailAddSta')
            duplicateList.forEach((value) => {
                addError(errorList, value)
                errorMsgs[value] = form_base_content.same_email
            })
        }
    };

    checkDisableCondition = (app, question) => {
        const { condition } = question;
        const conditionObj = condition && JSON.parse(condition);
        let isDisable = false;
        let defaultValue = null;
        if (conditionObj) {
            const { disableConditions } = conditionObj;
            if (disableConditions) {
                disableConditions.forEach(disableCondition => {
                    const { condition, displayValue } = disableCondition;
                    if (isAOFormConditionMatch(app, condition, question, false)) {
                        isDisable = true;
                        defaultValue = displayValue;
                    }
                });
            }
        }
        return [isDisable, defaultValue];
    };

    // Dialog handle
    showDialog = (dialogInfo) => {
        this.setState({
            dialogObj: dialogInfo
        });
    };

    closeDialog = () => {
        this.setState({
            dialogObj: null
        });
    };

    closeDialogAndScrollToTop = () => {
        this.setState({
            dialogObj: null
        }, () => {
            this.scrollToTop()
        });

    };

    backToAoFormHomePage = () => {
        history.push(paths.dashboard.path);
    };

    redirectToPreviousPage = () => {
        this.autoRedirectToNextPage(true)
    };

    redirectToNextPage = () => {
        this.autoRedirectToNextPage(false)
    };

    redirectToNextPageWithSave = () => {
        const { dialogObj } = this.state;
        if (dialogObj) {
            const newDialogObj = { ...dialogObj, disabled: true, backdrop: 'static' };
            this.setState({
                dialogObj: newDialogObj
            }, () => {
                const { saveAOForm, applicationInfo, countryListDatas, businessInfo } = this.props;
                const { currentSection } = this.state;
                const newApplicationInfo = replaceQuestion(applicationInfo, { ...currentSection, questionStatus: 1 });
                // const newSection = findQuestionById(newApplicationInfo, "S003");
                const businessScope = handleFindAnswerbyQuestionIndicator(newApplicationInfo, 'BusinessScope'); // json里隐藏‘经营范围’的value
                const [flattenObj, panelStatusObj] = handleJsonToAnswer(newApplicationInfo, countryListDatas);
                flattenObj.BusinessScope = businessScope;

                this.changeTypeOfVTAanswer(flattenObj);
                saveAOForm(newApplicationInfo,
                    flattenObj,
                    panelStatusObj,
                    businessInfo.qianHaiInfo)
                    .then(() => {
                        this.redirectToNextPage()
                    })
                    .catch(error => {
                        const { dialogObj } = this.state;
                        if (dialogObj) {
                            const newDialogObj = { ...dialogObj, disabled: false, backdrop: true };
                            this.setState({ dialogObj: newDialogObj }, () => {

                            });
                        }
                    })
            });
        }

    };

    autoRedirectToNextPage = (isPre = false) => {
        const { id } = this.state;
        const { applicationInfo } = this.props;
        if (id) {
            const nextId = findPreviousOrNextQuestionId(applicationInfo, id, isPre);
            if (nextId) {
                history.push(paths.aoform.path(nextId));
                return
            }
        }
        this.backToAoFormHomePage()
    };
    handleCheckboxOnClick = (event, questionRel) => {
        event.stopPropagation && event.stopPropagation();
        event.stopImmediatePropagation && event.stopImmediatePropagation();
        event.preventDefault();
        const { questionId } = questionRel;
        const { errorList, errorMsgs } = this.state;
        const tcErrorMsg = this.props.form_base_content.TC_link.errorMsg;
        if (errorList.indexOf(questionId) < 0 || (errorMsgs[questionId] !== tcErrorMsg)) {
            errorList.push(questionId);
            errorMsgs[questionId] = tcErrorMsg
            this.setState({
                errorList,
                errorMsgs
            })
        }
    }
    onClickTC = (event, questionRel, type) => {
        event.stopPropagation && event.stopPropagation();
        event.stopImmediatePropagation && event.stopImmediatePropagation();
        event.preventDefault();
        const { form_base_content } = this.props;
        this.removeTCError(questionRel, type);
        if (type === 'one') {
            this.showDialog({
                showModal: true,
                popupType: 'back',
                content: form_base_content.TC_prompt,
                backAction: this.closeDialog,
                confirmAction: this.closeDialog,
                closeAction: this.closeDialog,
                classnames: 'tc_dialog'
            });
        } else if (type === 'two') {
            window.open('https://personal.hsbc.com.cn/fusion/offers/segmentation/', '_blank');
        }
    }
    removeTCError = (questionRel, type) => {
        const { errorList, isTCdisabled } = this.state;
        const itemIndex = errorList.indexOf(questionRel.questionId);
        if (type === 'one') {
            isTCdisabled[0] = 'false';
        } else if (type === 'two') {
            isTCdisabled[1] = 'false';
        }
        const isAbled = isTCdisabled.every(item => item === 'false');
        if (isAbled && itemIndex !== -1) {
            errorList.splice(itemIndex, 1);
        }
        this.setState({
            isTCdisabled,
            errorList
        });
    }
    // button actions
    backAction = () => {
        const { applicationInfo, form_base_content } = this.props;
        const { currentSection, id } = this.state;
        if (applicationInfo) {
            const originCurrentSection = this.findCurrentSectionByApplication(applicationInfo, id);
            const originSectionStr = JSON.stringify(originCurrentSection);
            const currentSectionStr = JSON.stringify(currentSection);
            if (originSectionStr !== currentSectionStr) {
                this.showDialog({
                    showModal: true,
                    popupType: 'back',
                    content: form_base_content.back_prompt,
                    backAction: this.closeDialog,
                    confirmAction: this.redirectToPreviousPage,
                    closeAction: this.closeDialog
                });
                return;
            }
        }
        this.redirectToPreviousPage();
    };

    saveAction = () => {
        const { saveAOForm, applicationInfo, countryListDatas, businessInfo } = this.props;
        const { currentSection } = this.state;
        const connectedParties = isConnectedParties(currentSection);
        const section = connectedParties ? this.validateAndUpdateConnectedParties(currentSection) : currentSection;
        const newApplicationInfo = replaceQuestion(applicationInfo, { ...section, questionStatus: 1 });
        // const newSection = findQuestionById(newApplicationInfo, "S003");

        const businessScope = handleFindAnswerbyQuestionIndicator(newApplicationInfo, 'BusinessScope'); // json里隐藏‘经营范围’的value
        const [flattenObj, panelStatusObj] = handleJsonToAnswer(newApplicationInfo, countryListDatas);
        //answerDetails有前海回来‘经营范围’BusinessScope的value, FE界面不需要显示‘经营范围’，但不要清空它的value，保留隐藏传过去。 
        flattenObj.BusinessScope = businessScope;
        
        //RBBOB-15726 AC2 --------------------------------START
        if(this.state.id === "Q003-001") {
            const { resOrBusOpeSitCodeLevelSlectArray, resOrBusOpeSitCodeLevelSlectLastText, allText } = this.buildResOrBusOpeSitCodeLevelBusinessData();
            // 之前六位数填120104给ResOrBusOpeSitCode-> mapping地名在aoform, 现改相当是直接填：440115 广东省广州市南沙区
            // resOrBusOpeSitCodeLevelSlectLastText:120104 南开区, allText:440115 广东省广州市南沙区
            flattenObj.ResOrBusOpeSitCode = allText;
            flattenObj.ResOrBusOpeSitCodeLevel = resOrBusOpeSitCodeLevelSlectArray;//现在三级下拉菜单
        }
        //RBBOB-15726 AC2 --------------------------------END
        if (this.state.id === 'Q003-007') {
            let ConPer = [];
            let otherConPer = [];
            const { form_error_prompt } = this.state;
            const s = form_error_prompt.errorInfo.includes('：') ? '：' : ':';
            form_error_prompt.errorInfo = form_error_prompt.errorInfo.split(s)[0] + s;
            const isLS = this.isSelectLS(flattenObj);
            if (['SelfEmploy', 'PriOwn'].includes(businessInfo.qianHaiInfo.entityType.form)) {
                ConPer = this.getConPerCount(flattenObj, 'SoleProprietor');
                if (ConPer.length !== 1) {
                    form_error_prompt.errorInfo += form_error_prompt.errorInfo_SoleProprietor;
                    this.displayError(form_error_prompt);
                    return Promise.reject('SoleProprietor');
                }
                if(isLS){
                    form_error_prompt.errorInfo += form_error_prompt.errorInfo_LS;
                    this.displayError(form_error_prompt);
                    return Promise.reject('LS');
                }
            } else {
                ConPer = this.getConPerCount(flattenObj, 'LegRepPerson');
                if (ConPer.length !== 1) {
                    form_error_prompt.errorInfo += form_error_prompt.errorInfo_LegRepPerson;
                    this.displayError(form_error_prompt);
                    return Promise.reject('LegRepPerson');
                }
                if(isLS){
                    form_error_prompt.errorInfo += form_error_prompt.errorInfo_LS;
                    this.displayError(form_error_prompt);
                    return Promise.reject('LS');
                }
            }
            const ConPerInfo = this.handleConPerInfo(ConPer[0]);
            for (let key in ConPerInfo) {
                flattenObj[key] = ConPerInfo[key];
            }
        }
        this.changeTypeOfVTAanswer(flattenObj);
        const saveActionWithStatus = (status) => {
            const saveAOFormAction = connectedParties
                ? saveAOForm(newApplicationInfo,
                    flattenObj,
                    { [currentSection.questionIndicator]: status, ...panelStatusObj },
                    businessInfo.qianHaiInfo)
                : saveAOForm(newApplicationInfo,
                    flattenObj,
                    { [currentSection.questionIndicator]: status },
                    businessInfo.qianHaiInfo);
            saveAOFormAction
                .then(() => {
                    if (this.state.id === 'Q003-007') {
                        const { retrvInfo, countryListDatas, industryLevelList, sectionInfo, resOrBusOpeSitCodeLevelDatasRoots } = this.props;
                        if (retrvInfo && countryListDatas && industryLevelList && sectionInfo && resOrBusOpeSitCodeLevelDatasRoots) {
                            this.props.getBusandqs(this.props.applicationInfo, retrvInfo,
                                countryListDatas,
                                industryLevelList,
                                sectionInfo,
                                resOrBusOpeSitCodeLevelDatasRoots)
                        }
                    }
                    this.backToAoFormHomePage()
                })
                .catch(error => {
                })
        }
        this.validateForm(false)
            .then(() => {
                saveActionWithStatus("2")
            })
            .catch(error => {
                saveActionWithStatus("1")
            })
    };

    // This method is called when the user click on the next button.
    completeAction = () => {
        this.validateForm()
            .then(() => {
                const { completeAOForm, applicationInfo, countryListDatas, businessInfo } = this.props;
                const { currentSection } = this.state;

                //中文曾用名,中文营业名称->转全角
                //英文曾用名,英文营业名称->转半角
                if(currentSection && currentSection.questionIndicator === "CompanyInformation") {
                    let subQ = currentSection.subQuestions;
                    subQ && subQ.forEach((item,index) => {
                        let ua = item.userAnswer;
                        if(ua && ua.contents && ua.contents[0] && (item.questionIndicator === "BusRegFormerName" || item.questionIndicator === "TradingAsOrDoBusAsName")){
                            ua.contents[0] = ua.contents[0] ? ToDBC(ua.contents[0]) : "";//转全角
                        }
                        if(ua && ua.contents && ua.contents[0] && (item.questionIndicator === "BusRegFormerNameEN" || item.questionIndicator === "TradingAsOrDoBusAsNameEN")){
                            ua.contents[0] = ua.contents[0] ? ToCDB(ua.contents[0]) : "";//转半角
                        }
                    })
                }
                const newApplicationInfo = replaceQuestion(applicationInfo, { ...currentSection, questionStatus: 2 });

                const businessScope = handleFindAnswerbyQuestionIndicator(newApplicationInfo, 'BusinessScope'); // json里隐藏‘经营范围’的value
                // const newSection = findQuestionById(newApplicationInfo, "S003");
                const [flattenObj, panelStatusObj] = handleJsonToAnswer(newApplicationInfo, countryListDatas);
                //answerDetails有前海回来‘经营范围’BusinessScope的value, FE界面不需要显示‘经营范围’，但不要清空它的value，保留隐藏传过去。 
                flattenObj.BusinessScope = businessScope;

                //RBBOB-15726 AC2 --------------------------------START
                if(this.state.id === "Q003-001") {
                    const { resOrBusOpeSitCodeLevelSlectArray, resOrBusOpeSitCodeLevelSlectLastText, allText } = this.buildResOrBusOpeSitCodeLevelBusinessData();
                    // 之前六位数填120104给ResOrBusOpeSitCode-> mapping地名在aoform, 现改相当是直接填：440115 广东省广州市南沙区
                    // resOrBusOpeSitCodeLevelSlectLastText:120104 南开区, allText:440115 广东省广州市南沙区
                    flattenObj.ResOrBusOpeSitCode = allText;
                    flattenObj.ResOrBusOpeSitCodeLevel = resOrBusOpeSitCodeLevelSlectArray;//现在三级下拉菜单
                }
                //RBBOB-15726 AC2 --------------------------------END
                if (this.state.id === 'Q003-004') { // 财务资料 WCB-8373 RBBOB-EASTV
                    const onShore = !businessInfo.companyInfo.offShore;
                    const capitalAmount = flattenObj.CapitalAmount;
                    const fctCapAmt = flattenObj.FctCapAmt;
                    if (onShore) {
                        if (capitalAmount === "") {
                            return Promise.reject('CapitalAmount'); // "注册资本"不能为空
                        } else if (fctCapAmt === "") {
                            return Promise.reject('FctCapAmt'); // "实收资本"不能为空
                        }
                    }
                }
                if (this.state.id === 'Q003-007') {
                    let ConPer = [];
                    const isLS = this.isSelectLS(flattenObj);
                    if (['SelfEmploy', 'PriOwn'].includes(businessInfo.qianHaiInfo.entityType.form)) {
                        ConPer = this.getConPerCount(flattenObj, 'SoleProprietor');
                        if (ConPer.length !== 1) { // 必须只要一个个人独资企业／个体工商户
                            return Promise.reject('SoleProprietor');
                        }
                        if(isLS){
                            return Promise.reject('LS');  
                        }
                    } else {
                        ConPer = this.getConPerCount(flattenObj, 'LegRepPerson'); 
                        if (ConPer.length !== 1) { // 必须只要一个法定代表人
                            return Promise.reject('LegRepPerson');
                        }
                        if(isLS){
                            return Promise.reject('LS');  
                        }
                    }
                    const ConPerInfo = this.handleConPerInfo(ConPer[0]);
                    for (let key in ConPerInfo) {
                        flattenObj[key] = ConPerInfo[key];
                    }
                }

                // WCB-7848 START
                if (this.state.id === 'Q003-004') {
                    if (businessInfo.companyInfo.registerCountry === 'CN' && flattenObj.OthKeyFinDataAssAmount === '') {
                        return Promise.reject('AssetSize');
                    }
                }
                // WCB-7848 END

                this.changeTypeOfVTAanswer(flattenObj);
                return isConnectedParties(currentSection)
                    ? completeAOForm(newApplicationInfo,
                        flattenObj,
                        { [currentSection.questionIndicator]: '2', ...panelStatusObj },
                        businessInfo.qianHaiInfo)
                    : completeAOForm(newApplicationInfo,
                        flattenObj,
                        { [currentSection.questionIndicator]: '2' },
                        businessInfo.qianHaiInfo)
            })
            .then(() => {
                if (this.state.id === 'Q003-007') {
                    const { retrvInfo, countryListDatas, industryLevelList, sectionInfo, resOrBusOpeSitCodeLevelDatasRoots } = this.props;
                    if (retrvInfo && countryListDatas && industryLevelList && sectionInfo && resOrBusOpeSitCodeLevelDatasRoots) {
                        this.props.getBusandqs(this.props.applicationInfo, retrvInfo,
                            countryListDatas,
                            industryLevelList,
                            sectionInfo,
                            resOrBusOpeSitCodeLevelDatasRoots)
                    }
                }
                const { form_error_prompt } = this.state;
                const s = form_error_prompt.errorInfo.includes('：') ? '：' : ':';
                form_error_prompt.errorInfo = form_error_prompt.errorInfo.split(s)[0] + s;
                this.setState({ isShowError: false, form_error_prompt: form_error_prompt }, () => {
                    this.redirectToNextPage()
                })
            })
            .catch(error => {
                const { form_error_prompt } = this.state;
                const s = form_error_prompt.errorInfo.includes('：') ? '：' : ':';
                form_error_prompt.errorInfo = form_error_prompt.errorInfo.split(s)[0] + s;
                if (Array.isArray(error)) {
                    this.displayError(form_error_prompt);
                } else if (error === 'SoleProprietor') {
                    form_error_prompt.errorInfo += form_error_prompt.errorInfo_SoleProprietor;
                    this.displayError(form_error_prompt);
                } else if (error === 'LegRepPerson') {
                    form_error_prompt.errorInfo += form_error_prompt.errorInfo_LegRepPerson;
                    this.displayError(form_error_prompt);
                } else if (error === 'AssetSize') {
                    form_error_prompt.errorInfo += form_error_prompt.errorInfo_AssetSize;
                    this.displayError(form_error_prompt);
                } else if (error === 'CapitalAmount') {
                    form_error_prompt.errorInfo += form_error_prompt.errorInfo_CapitalAmount;
                    this.displayError(form_error_prompt);
                } else if (error === 'FctCapAmt') {
                    form_error_prompt.errorInfo += form_error_prompt.errorInfo_FctCapAmt;
                    this.displayError(form_error_prompt);
                } else if (error === "incorrectAmount") {
                    form_error_prompt.errorInfo += form_error_prompt.errorInfo_incorrectAmount;
                    this.displayError(form_error_prompt);
                } else if (error === "LS") {
                    form_error_prompt.errorInfo += form_error_prompt.errorInfo_LS;
                    this.displayError(form_error_prompt);
                }
            });
    };

    changeTypeOfVTAanswer = (flattenObj) => {
        if (flattenObj && flattenObj.Esta && isArray(flattenObj.Esta)) {
            const { businessInfo } = this.props;
            const isEmailInv = flattenObj.Esta.some(item => item.EmailUsage && item.EmailUsage.indexOf('Einvoice') !== -1);
            if (isEmailInv) {
                flattenObj.TypeOfVATInv = "EmailInv";
            } else {
                flattenObj.TypeOfVATInv = "PaperInv";
            }
            businessInfo.answerDetails = flattenObj;
        }   
    }

    // render
    render() {
        const { currentSection, dialogObj } = this.state;
        const { form_base_content, businessInfo } = this.props;
        return (currentSection && form_base_content) ? (
            <Grid className="dynamic-form ao-form">
                {this.handleJsonToView(currentSection)}
                <AOForm.BottomButtonsGroup
                    content={form_base_content.bottomButtonsContent}
                    backAction={this.backAction}
                    saveAction={this.saveAction}
                    completeFormAction={this.completeAction}
                />
                {
                    dialogObj ?
                        <AOForm.PopupModel
                            {...dialogObj}
                        /> : null
                }
            </Grid>
        ) : null;
    }
}

AOFormContainer.propTypes = {
    formJson: PropTypes.string,
};

const mapStateToProps = (state = {}) => {
    const {
        app: {
            retrvInfo,
            industryLevelList,
            sectionInfo,
            selectedLanguage,
            applicationInfo,
            countryListDatas,
            businessInfo,
            i18n: {
                form_base_content,
                stepInfo,
                aoStepTitle,
                pageTitle
            },
            allCountryDatas,
            resOrBusOpeSitCodeLevelDatasRoots
        }
    } = state;
    return {
        retrvInfo,
        industryLevelList,
        sectionInfo,
        selectedLanguage,
        applicationInfo,
        form_base_content,
        stepInfo,
        aoStepTitle,
        countryListDatas,
        businessInfo,
        pageTitle,
        allCountryDatas,
        resOrBusOpeSitCodeLevelDatasRoots
    }
};

export default connect(mapStateToProps, {
    saveAOForm,
    completeAOForm,
    getBusandqs,
    saveCountryList,
    saveBusinessInfo
})(AOFormContainer);


// WEBPACK FOOTER //
// ./src/views/AOForm/container/index.js